import { defineComponent as c, computed as k, openBlock as a, createElementBlock as l, normalizeClass as p, renderSlot as g, createElementVNode as o, mergeProps as U, ref as M, watch as S, withDirectives as A, vModelDynamic as Jt, isRef as Xt, getCurrentInstance as Yt, onMounted as te, nextTick as ee, unref as h, getCurrentScope as oe, onScopeDispose as se, useSlots as st, createVNode as L, createCommentVNode as x, createBlock as D, resolveDynamicComponent as rt, toDisplayString as C, createStaticVNode as z, Fragment as V, createTextVNode as R, withModifiers as Ct, withCtx as N, vModelText as ct, renderList as Z, vModelCheckbox as q, vModelSelect as kt, resolveComponent as $t, resolveDirective as ne, toRefs as j, vModelRadio as ae, normalizeStyle as le } from "vue";
const re = ["data-test-id", "disabled"], wt = /* @__PURE__ */ c({
  __name: "cl-button",
  props: {
    dataTestId: { default: "" },
    variant: { default: "default" },
    size: { default: "medium" },
    fullwidth: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["on-click"],
  setup(n, { emit: t }) {
    const e = n, s = t, i = () => {
      s("on-click");
    }, r = {
      default: "tw-text-dorian-gray-900 tw-bg-white hover:tw-bg-dorian-gray-50/20 active:tw-bg-dorian-gray-50/60 focus:tw-outline-dorian-gray-50 disabled:tw-bg-dorian-gray-200/60 disabled:tw-text-white dark:disabled:tw-text-dorian-gray-200",
      secondary: "tw-text-white tw-bg-secondary-500 hover:tw-bg-secondary-600 active:tw-bg-secondary-700 focus:tw-outline-secondary-500/30 disabled:tw-bg-dorian-gray-200/60 dark:disabled:tw-text-dorian-gray-200",
      "secondary-outline": "tw-text-secondary-500 tw-bg-transparent tw-border-0 tw-ring-2 tw-ring-inset tw-ring-secondary-500 enabled:hover:tw-bg-secondary-600 enabled:hover:tw-ring-secondary-600 enabled:hover:tw-text-white enabled:active:tw-bg-secondary-600 enabled:active:tw-text-white enabled:focus:tw-outline-secondary-500/30 disabled:tw-ring-dorian-gray-200/60 disabled:tw-text-dorian-gray-200/60 disabled:tw-bg-transparent",
      "secondary-ghost": "tw-text-secondary-500 tw-bg-transparent tw-border-0 tw-ring-0 enabled:hover:tw-bg-dorian-gray-50 enabled:hover:tw-text-secondary-500 enabled:active:tw-bg-secondary-600 enabled:active:tw-text-white enabled:focus:tw-outline-secondary-500/30 disabled:tw-ring-dorian-gray-200/60 disabled:tw-text-dorian-gray-200/60 disabled:tw-bg-transparent",
      info: "tw-text-white tw-bg-info-500 hover:tw-bg-info-600 active:tw-bg-info-700 focus:tw-outline-info-500/30 disabled:tw-bg-dorian-gray-200/60 dark:disabled:tw-text-dorian-gray-200",
      success: "tw-text-white tw-bg-success-500 hover:tw-bg-success-600 active:tw-bg-success-700 focus:tw-outline-success-500/30 disabled:tw-bg-dorian-gray-200/60 dark:disabled:tw-text-dorian-gray-200",
      warning: "tw-text-white tw-bg-warning-500 hover:tw-bg-warning-600 active:tw-bg-warning-700 focus:tw-outline-warning-500/30 disabled:tw-bg-dorian-gray-200/60 dark:disabled:tw-text-dorian-gray-200",
      danger: "tw-text-white tw-bg-danger-500 hover:tw-bg-danger-600 active:tw-bg-danger-700 focus:tw-outline-danger-500/30 disabled:tw-bg-dorian-gray-200/60 dark:disabled:tw-text-dorian-gray-200",
      "danger-outline": "tw-text-danger-500 tw-bg-transparent tw-border-0 tw-ring-2 tw-ring-inset tw-ring-danger-500 enabled:hover:tw-bg-danger-600 enabled:hover:tw-ring-danger-600 enabled:hover:tw-text-white enabled:active:tw-bg-danger-600 enabled:active:tw-text-white enabled:focus:tw-outline-danger-500/30 disabled:tw-ring-dorian-gray-200/60 disabled:tw-text-dorian-gray-200/60 disabled:tw-bg-transparent",
      "link-secondary": "tw-bg-none tw-text-secondary-500 hover:tw-text-secondary-600 active:tw-text-secondary-800 focus:tw-outline-secondary-500/30",
      "i-am-the-danger": "tw-bg-none tw-text-danger-500 hover:tw-text-danger-600 active:tw-text-danger-800 focus:tw-outline-danger-500/30"
    }, d = {
      small: "tw-text-sm tw-py-1 tw-px-2",
      medium: "tw-text-base tw-py-2 tw-px-6",
      large: "tw-text-lg tw-py-3 tw-px-10"
    }, w = k(() => [d[e.size], r[e.variant]]);
    return (u, m) => (a(), l("button", {
      class: p(["tw-m-1 tw-items-center tw-rounded tw-font-medium tw-outline-none tw-outline-offset-0 tw-transition-all focus:tw-outline-4 disabled:tw-cursor-not-allowed", [
        w.value,
        e.fullwidth ? "tw-flex tw-w-full tw-justify-center" : "tw-inline-flex"
      ]]),
      "data-test-id": e.dataTestId,
      disabled: e.disabled,
      onClick: i
    }, [
      g(u.$slots, "default")
    ], 10, re));
  }
}), T = (n, t) => {
  const e = n.__vccOpts || n;
  for (const [s, i] of t)
    e[s] = i;
  return e;
}, ie = {}, de = {
  class: "tw-mb-4 tw-flex tw-flex-col",
  role: "group"
};
function we(n, t) {
  return a(), l("div", de, [
    g(n.$slots, "default")
  ]);
}
const Ar = /* @__PURE__ */ T(ie, [["render", we]]), ce = { class: "tw-relative" }, ue = ["for"], Pr = /* @__PURE__ */ c({
  __name: "cl-form-label",
  props: {
    labelFor: {},
    position: { default: "top" }
  },
  setup(n) {
    const t = {
      top: "tw-mb-1 tw-block tw-text-base tw-font-normal tw-text-dorian-gray-500",
      border: "tw--top-3.5 tw-absolute tw-left-6 tw-z-10 tw-h-5 tw-bg-white tw-px-1 tw-text-dorian-gray-200"
    }, e = n, s = k(() => [t[e.position]]);
    return (i, r) => (a(), l("div", ce, [
      o("label", U({
        for: e.labelFor,
        class: s.value
      }, i.$attrs), [
        g(i.$slots, "default")
      ], 16, ue)
    ]));
  }
}), he = ["id", "name", "type", "autofocus", "disabled", "readonly", "placeholder", "data-test-id", "step", "min", "max", "maxlength"], pe = "focus:tw-border-secondary-500 focus:tw-ring-4 focus:tw-ring-secondary-500/10", fe = "disabled:tw-cursor-not-allowed disabled:tw-bg-dorian-gray-50 disabled:tw-text-dorian-gray-500/50 disabled:tw-outline-none", ge = "read-only:tw-cursor-default read-only:tw-bg-dorian-gray-50 read-only:tw-text-dorian-gray-500/50 read-only:tw-outline-none", Er = /* @__PURE__ */ c({
  __name: "cl-form-input",
  props: {
    inputRef: { default: void 0 },
    id: {},
    name: {},
    value: {},
    size: { default: "medium" },
    type: { default: "text" },
    placeholder: { default: "" },
    state: { type: [Boolean, null], default: null },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    autofocus: { type: Boolean, default: !1 },
    testId: { default: "" },
    step: { default: void 0 },
    min: { default: void 0 },
    max: { default: void 0 },
    maxlength: { default: void 0 }
  },
  emits: ["update:value", "on-blur", "on-keyup", "on-keydown", "on-paste"],
  setup(n, { emit: t }) {
    const e = n, s = t, i = M(e.value), r = {
      small: "tw-text-sm tw-py-1 tw-px-3",
      medium: "tw-text-base tw-py-2 tw-px-3",
      large: "tw-text-lg tw-py-3 tw-px-3"
    }, d = {
      none: "tw-border-dorian-gray-100/80",
      valid: "tw-border-success-500",
      error: "tw-border-danger-500"
    }, w = k(() => [
      r[e.size],
      e.state === null ? d.none : e.state ? d.valid : d.error,
      pe,
      fe,
      ge
    ]);
    S(
      () => e.value,
      () => {
        i.value = e.value;
      }
    ), S(i, (y) => {
      s("update:value", y);
    });
    const u = () => {
      s("on-blur");
    }, m = (y) => {
      s("on-keyup", y);
    }, v = (y) => {
      s("on-keydown", y);
    }, $ = (y) => {
      s("on-paste", y);
    };
    return (y, B) => A((a(), l("input", {
      id: e.id,
      ref: y.inputRef,
      "onUpdate:modelValue": B[0] || (B[0] = (I) => i.value = I),
      class: p(["tw-block tw-w-full tw-rounded tw-border tw-bg-white tw-text-dorian-gray-500 tw-outline-none tw-ring-offset-1 tw-transition-all", [w.value]]),
      name: e.name,
      type: e.type,
      autofocus: e.autofocus,
      disabled: e.disabled,
      readonly: e.readonly,
      placeholder: e.placeholder,
      "data-test-id": e.testId,
      step: e.step,
      min: e.min,
      max: e.max,
      maxlength: e.maxlength,
      onBlur: u,
      onKeyup: m,
      onKeydown: v,
      onPaste: $
    }, null, 42, he)), [
      [Jt, i.value]
    ]);
  }
}), be = {
  class: "tw-inline-block",
  role: "status"
}, Nr = /* @__PURE__ */ c({
  __name: "cl-spinner",
  props: {
    variant: { default: "default" },
    size: { default: "medium" }
  },
  setup(n) {
    const t = n, e = {
      default: "tw-fill-dorian-gray-500",
      secondary: "tw-fill-secondary-500",
      info: "tw-fill-info-500",
      success: "tw-fill-success-500",
      warning: "tw-fill-warning-500",
      danger: "tw-fill-danger-500"
    }, s = {
      small: "tw-w-4 tw-h-4",
      medium: "tw-w-6 tw-h-6",
      large: "tw-w-8 tw-h-8",
      xl: "tw-w-10 tw-h-10"
    }, i = k(() => [s[t.size], e[t.variant]]);
    return (r, d) => (a(), l("div", be, [
      (a(), l("svg", {
        "aria-hidden": "true",
        class: p(["tw-m-1 tw-inline tw-animate-spin tw-text-dorian-gray-50", i.value]),
        viewBox: "0 0 100 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, d[0] || (d[0] = [
        o("path", {
          d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
          fill: "currentColor"
        }, null, -1),
        o("path", {
          d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
          fill: "currentFill"
        }, null, -1)
      ]), 2)),
      d[1] || (d[1] = o("span", { class: "tw-sr-only" }, "Loading...", -1))
    ]));
  }
}), ve = /* @__PURE__ */ c({
  __name: "cl-hr",
  props: {
    size: { default: "lg" }
  },
  setup(n) {
    const t = n, e = k(() => t.size === "lg" ? "tw-my-6" : "tw-my-4");
    return (s, i) => (a(), l("hr", {
      class: p(["tw-border-dorian-gray-100", e.value])
    }, null, 2));
  }
}), Or = /* @__PURE__ */ c({
  __name: "cl-p",
  props: {
    weight: { default: "normal" },
    size: { default: "base" }
  },
  setup(n) {
    const t = n, e = {
      xs: "tw-text-xs",
      sm: "tw-text-sm",
      base: "tw-text-base",
      lg: "tw-text-lg"
    }, s = {
      thin: "tw-font-thin",
      extralight: "tw-font-extralight",
      light: "tw-font-light",
      normal: "tw-font-normal",
      medium: "tw-font-medium"
    }, i = k(() => [
      "cl-p tw-mb-3 tw-text-dorian-gray-500",
      e[t.size],
      s[t.weight]
    ]);
    return (r, d) => (a(), l("p", {
      class: p(i.value)
    }, [
      g(r.$slots, "default")
    ], 2));
  }
});
var ft;
const Mt = typeof window < "u", me = (n) => typeof n == "string", Bt = () => {
}, _e = Mt && ((ft = window == null ? void 0 : window.navigator) == null ? void 0 : ft.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function it(n) {
  return typeof n == "function" ? n() : h(n);
}
function ye(n) {
  return n;
}
function xe(n) {
  return oe() ? (se(n), !0) : !1;
}
function Ce(n, t = !0) {
  Yt() ? te(n) : t ? n() : ee(n);
}
function ke(n = !1, t = {}) {
  const {
    truthyValue: e = !0,
    falsyValue: s = !1
  } = t, i = Xt(n), r = M(n);
  function d(w) {
    if (arguments.length)
      return r.value = w, r.value;
    {
      const u = it(e);
      return r.value = r.value === u ? it(s) : u, r.value;
    }
  }
  return i ? d : [r, d];
}
function tt(n) {
  var t;
  const e = it(n);
  return (t = e == null ? void 0 : e.$el) != null ? t : e;
}
const ut = Mt ? window : void 0;
function et(...n) {
  let t, e, s, i;
  if (me(n[0]) || Array.isArray(n[0]) ? ([e, s, i] = n, t = ut) : [t, e, s, i] = n, !t)
    return Bt;
  Array.isArray(e) || (e = [e]), Array.isArray(s) || (s = [s]);
  const r = [], d = () => {
    r.forEach((v) => v()), r.length = 0;
  }, w = (v, $, y, B) => (v.addEventListener($, y, B), () => v.removeEventListener($, y, B)), u = S(() => [tt(t), it(i)], ([v, $]) => {
    d(), v && r.push(...e.flatMap((y) => s.map((B) => w(v, y, B, $))));
  }, { immediate: !0, flush: "post" }), m = () => {
    u(), d();
  };
  return xe(m), m;
}
let gt = !1;
function G(n, t, e = {}) {
  const { window: s = ut, ignore: i = [], capture: r = !0, detectIframe: d = !1 } = e;
  if (!s)
    return;
  _e && !gt && (gt = !0, Array.from(s.document.body.children).forEach((y) => y.addEventListener("click", Bt)));
  let w = !0;
  const u = (y) => i.some((B) => {
    if (typeof B == "string")
      return Array.from(s.document.querySelectorAll(B)).some((I) => I === y.target || y.composedPath().includes(I));
    {
      const I = tt(B);
      return I && (y.target === I || y.composedPath().includes(I));
    }
  }), v = [
    et(s, "click", (y) => {
      const B = tt(n);
      if (!(!B || B === y.target || y.composedPath().includes(B))) {
        if (y.detail === 0 && (w = !u(y)), !w) {
          w = !0;
          return;
        }
        t(y);
      }
    }, { passive: !0, capture: r }),
    et(s, "pointerdown", (y) => {
      const B = tt(n);
      B && (w = !y.composedPath().includes(B) && !u(y));
    }, { passive: !0 }),
    d && et(s, "blur", (y) => {
      var B;
      const I = tt(n);
      ((B = s.document.activeElement) == null ? void 0 : B.tagName) === "IFRAME" && !(I != null && I.contains(s.document.activeElement)) && t(y);
    })
  ].filter(Boolean);
  return () => v.forEach((y) => y());
}
const bt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, vt = "__vueuse_ssr_handlers__";
bt[vt] = bt[vt] || {};
var mt;
(function(n) {
  n.UP = "UP", n.RIGHT = "RIGHT", n.DOWN = "DOWN", n.LEFT = "LEFT", n.NONE = "NONE";
})(mt || (mt = {}));
var $e = Object.defineProperty, _t = Object.getOwnPropertySymbols, Me = Object.prototype.hasOwnProperty, Be = Object.prototype.propertyIsEnumerable, yt = (n, t, e) => t in n ? $e(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e, Le = (n, t) => {
  for (var e in t || (t = {}))
    Me.call(t, e) && yt(n, e, t[e]);
  if (_t)
    for (var e of _t(t))
      Be.call(t, e) && yt(n, e, t[e]);
  return n;
};
const He = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
Le({
  linear: ye
}, He);
function Ie(n = {}) {
  const {
    window: t = ut,
    initialWidth: e = 1 / 0,
    initialHeight: s = 1 / 0,
    listenOrientation: i = !0,
    includeScrollbar: r = !0
  } = n, d = M(e), w = M(s), u = () => {
    t && (r ? (d.value = t.innerWidth, w.value = t.innerHeight) : (d.value = t.document.documentElement.clientWidth, w.value = t.document.documentElement.clientHeight));
  };
  return u(), Ce(u), et("resize", u, { passive: !0 }), i && et("orientationchange", u, { passive: !0 }), { width: d, height: w };
}
const ze = { class: "tw-mb-3 tw-flex tw-items-center tw-p-4" }, Ve = {
  key: 0,
  class: "tw-ml-3 tw-flex tw-w-full tw-justify-center",
  "data-test-id": "company-logo"
}, Te = { href: "/" }, Se = {
  key: 1,
  class: "tw-ml-3 tw-p-4",
  "data-test-id": "products-section"
}, je = {
  key: 2,
  class: "tw-ml-3 tw-p-4",
  "data-test-id": "users-section"
}, Ze = {
  key: 0,
  "data-test-id": "dropdown-select"
}, De = { class: "tw-mt-auto tw-p-4" }, Ae = {
  key: 0,
  class: "tw-mb-3",
  "data-test-id": "info-section"
}, Fr = /* @__PURE__ */ c({
  __name: "cl-sidebar",
  setup(n) {
    const t = st(), e = M(!1), { width: s } = Ie();
    function i() {
      e.value = !e.value;
    }
    return S(
      s,
      (r) => {
        r > 1024 && e.value && (e.value = !1), r < 1024 && !e.value && (e.value = !0);
      },
      { immediate: !0 }
    ), (r, d) => (a(), l("aside", {
      class: p(["tw-z-30 tw-m-0 tw-flex tw-flex-col tw-bg-aside-600 tw-p-0 tw-align-top tw-text-white tw-transition-all dark:tw-text-dorian-gray-500 max-lg:tw-absolute max-lg:tw-bottom-0 max-lg:tw-left-0 max-lg:tw-top-0", [e.value ? "tw-w-14" : "tw-min-w-[375px]"]])
    }, [
      o("div", ze, [
        o("div", null, [
          o("button", {
            "data-test-id": "toggle-btn",
            onClick: i
          }, [
            L(h(Ke), {
              width: "24px",
              height: "24px"
            })
          ])
        ]),
        h(t)["company-logo"] ? (a(), l("div", Ve, [
          o("a", Te, [
            g(r.$slots, "company-logo", { isClosed: e.value })
          ])
        ])) : x("", !0),
        h(t)["products-section"] ? (a(), l("div", Se, [
          g(r.$slots, "products-section", { isClosed: e.value })
        ])) : x("", !0),
        h(t)["users-section"] ? (a(), l("div", je, [
          g(r.$slots, "users-section", { isClosed: e.value })
        ])) : x("", !0)
      ]),
      h(t)["dropdown-select"] ? (a(), l("div", Ze, [
        g(r.$slots, "dropdown-select", { isClosed: e.value })
      ])) : x("", !0),
      h(t)["side-nav"] ? (a(), l("div", {
        key: 1,
        "data-test-id": "side-nav",
        class: p(["tw-relative tw-my-3 tw-h-full", !e.value && "tw-overflow-y-auto"])
      }, [
        g(r.$slots, "side-nav", { isClosed: e.value })
      ], 2)) : x("", !0),
      o("div", De, [
        h(t)["info-section"] ? (a(), l("div", Ae, [
          g(r.$slots, "info-section")
        ])) : x("", !0)
      ])
    ], 2));
  }
}), Pe = {
  key: 0,
  class: "tw-w-full"
}, Ee = ["href"], Ne = ["data-test-id"], Oe = {
  key: 1,
  class: "tw-w-full"
}, Fe = ["href"], Re = ["data-test-id"], Ue = { class: "tw-flex tw-flex-nowrap tw-items-center" }, We = { class: "tw-ml-2" }, Rr = /* @__PURE__ */ c({
  __name: "cl-sidebar-nav-item-parent",
  props: {
    label: {},
    icon: {},
    isClosed: { type: Boolean },
    navigate: {},
    href: {},
    isActive: { type: Boolean },
    dataTestId: { default: "" },
    disabled: { type: Boolean, default: !1 }
  },
  setup(n) {
    return (t, e) => t.isClosed ? (a(), l("div", Pe, [
      o("a", {
        href: t.href,
        class: p({
          "tw-pointer-events-none": t.disabled
        }),
        onClick: e[0] || (e[0] = //@ts-ignore
        (...s) => t.navigate && t.navigate(...s))
      }, [
        o("div", {
          class: p(["tw-flex tw-cursor-pointer tw-items-center tw-gap-4 tw-p-4 hover:tw-bg-aside-400", {
            "tw-bg-aside-400 tw-px-4 tw-font-bold tw-shadow-[inset_0.1875rem_0] tw-shadow-white tw-transition-all dark:tw-shadow-dorian-gray-500": t.isActive,
            "tw-text-dorian-gray-200": t.disabled
          }]),
          "data-test-id": t.dataTestId
        }, [
          (a(), D(rt(t.icon)))
        ], 10, Ne)
      ], 10, Ee)
    ])) : (a(), l("div", Oe, [
      o("a", {
        href: t.href,
        class: p({
          "tw-pointer-events-none": t.disabled
        }),
        onClick: e[2] || (e[2] = //@ts-ignore
        (...s) => t.navigate && t.navigate(...s))
      }, [
        o("div", {
          class: p(["tw-flex tw-cursor-pointer tw-items-center tw-justify-between tw-gap-4 tw-p-4 hover:tw-bg-aside-400", {
            "tw-bg-aside-400 tw-px-4 tw-font-bold tw-shadow-[inset_0.1875rem_0] tw-shadow-white tw-transition-all dark:tw-shadow-dorian-gray-500": t.isActive,
            "tw-text-dorian-gray-200": t.disabled
          }]),
          "data-test-id": t.dataTestId,
          onClick: e[1] || (e[1] = //@ts-ignore
          (...s) => t.navigate && t.navigate(...s))
        }, [
          o("div", Ue, [
            (a(), D(rt(t.icon))),
            o("span", We, C(t.label), 1)
          ]),
          g(t.$slots, "pill")
        ], 10, Re)
      ], 10, Fe)
    ]));
  }
}), Ge = ["width", "height"], Ur = /* @__PURE__ */ c({
  __name: "cl-icon-columns-gap",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      class: "icon icon-tabler",
      width: t.width,
      height: t.height,
      viewBox: "0 0 16 16"
    }, e[0] || (e[0] = [
      o("path", { d: "M6 1v3H1V1h5zM1 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1zm14 12v3h-5v-3h5zm-5-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-5zM6 8v7H1V8h5zM1 7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H1zm14-6v7h-5V1h5zm-5-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-5z" }, null, -1)
    ]), 8, Ge));
  }
}), Qe = ["width", "height"], Ke = /* @__PURE__ */ c({
  __name: "cl-icon-list",
  props: {
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: "tw-inline-flex",
      width: t.width,
      height: t.height
    }, s[0] || (s[0] = [
      o("path", {
        "fill-rule": "evenodd",
        d: "M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
      }, null, -1)
    ]), 8, Qe));
  }
}), qe = ["width", "height"], Wr = /* @__PURE__ */ c({
  __name: "cl-icon-box-arrow-in-left",
  props: {
    fill: { default: "white" },
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: p(["tw-inline-flex", `tw-fill-${t.fill}`]),
      viewBox: "0 0 16 16",
      width: t.width,
      height: t.height
    }, s[0] || (s[0] = [
      o("path", {
        "fill-rule": "evenodd",
        d: "M10 3.5a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 1 0v2A1.5 1.5 0 0 1 9.5 14h-8A1.5 1.5 0 0 1 0 12.5v-9A1.5 1.5 0 0 1 1.5 2h8A1.5 1.5 0 0 1 11 3.5v2a.5.5 0 0 1-1 0v-2z"
      }, null, -1),
      o("path", {
        "fill-rule": "evenodd",
        d: "M4.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H14.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z"
      }, null, -1)
    ]), 10, qe));
  }
}), Je = ["stroke", "width", "height"], Gr = /* @__PURE__ */ c({
  __name: "cl-icon-arrow-up-right",
  props: {
    width: { default: "16px" },
    height: { default: "16px" },
    stroke: { default: "2" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "tw-inline-flex",
      viewBox: "0 0 16 16",
      stroke: t.stroke,
      width: t.width,
      height: t.height
    }, s[0] || (s[0] = [
      o("path", {
        "fill-rule": "evenodd",
        d: "M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0v-6z"
      }, null, -1)
    ]), 8, Je));
  }
}), Xe = ["width", "height"], Qr = /* @__PURE__ */ c({
  __name: "cl-icon-pencil-square",
  props: {
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "tw-inline-flex",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      width: t.width,
      height: t.height
    }, s[0] || (s[0] = [
      o("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" }, null, -1),
      o("path", {
        "fill-rule": "evenodd",
        d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
      }, null, -1)
    ]), 8, Xe));
  }
}), Ye = {}, to = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-dashboard",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function eo(n, t) {
  return a(), l("svg", to, t[0] || (t[0] = [
    o("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null, -1),
    o("path", { d: "M12 13m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" }, null, -1),
    o("path", { d: "M13.45 11.55l2.05 -2.05" }, null, -1),
    o("path", { d: "M6.4 20a9 9 0 1 1 11.2 0z" }, null, -1)
  ]));
}
const Kr = /* @__PURE__ */ T(Ye, [["render", eo]]), oo = {}, so = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-flag-3",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function no(n, t) {
  return a(), l("svg", so, t[0] || (t[0] = [
    o("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null, -1),
    o("path", { d: "M5 14h14l-4.5 -4.5l4.5 -4.5h-14v16" }, null, -1)
  ]));
}
const qr = /* @__PURE__ */ T(oo, [["render", no]]), ao = {}, lo = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-bulb",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function ro(n, t) {
  return a(), l("svg", lo, t[0] || (t[0] = [
    o("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null, -1),
    o("path", { d: "M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7" }, null, -1),
    o("path", { d: "M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3" }, null, -1),
    o("path", { d: "M9.7 17l4.6 0" }, null, -1)
  ]));
}
const Jr = /* @__PURE__ */ T(ao, [["render", ro]]), io = {}, wo = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-chart-bar",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function co(n, t) {
  return a(), l("svg", wo, t[0] || (t[0] = [
    z('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M3 12m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path><path d="M9 8m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path><path d="M15 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path><path d="M4 20l14 0"></path>', 5)
  ]));
}
const Xr = /* @__PURE__ */ T(io, [["render", co]]), uo = {}, ho = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-recharging",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function po(n, t) {
  return a(), l("svg", ho, t[0] || (t[0] = [
    z('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M7.038 4.5a9 9 0 0 0 -2.495 2.47"></path><path d="M3.186 10.209a9 9 0 0 0 0 3.508"></path><path d="M4.5 16.962a9 9 0 0 0 2.47 2.495"></path><path d="M10.209 20.814a9 9 0 0 0 3.5 0"></path><path d="M16.962 19.5a9 9 0 0 0 2.495 -2.47"></path><path d="M20.814 13.791a9 9 0 0 0 0 -3.508"></path><path d="M19.5 7.038a9 9 0 0 0 -2.47 -2.495"></path><path d="M13.791 3.186a9 9 0 0 0 -3.508 -.02"></path><path d="M12 8l-2 4h4l-2 4"></path><path d="M12 21a9 9 0 0 0 0 -18"></path>', 11)
  ]));
}
const Yr = /* @__PURE__ */ T(uo, [["render", po]]), fo = {}, go = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-settings",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function bo(n, t) {
  return a(), l("svg", go, t[0] || (t[0] = [
    o("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null, -1),
    o("path", { d: "M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" }, null, -1),
    o("path", { d: "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" }, null, -1)
  ]));
}
const t1 = /* @__PURE__ */ T(fo, [["render", bo]]), vo = ["width", "height"], e1 = /* @__PURE__ */ c({
  __name: "tabler-icon-users",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-users",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, e[0] || (e[0] = [
      z('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"></path><path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path><path d="M21 21v-2a4 4 0 0 0 -3 -3.85"></path>', 5)
    ]), 8, vo));
  }
}), mo = ["width", "height"], o1 = /* @__PURE__ */ c({
  __name: "tabler-icon-building-skyscraper",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-building-skyscraper",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, e[0] || (e[0] = [
      z('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M3 21l18 0"></path><path d="M5 21v-14l8 -4v18"></path><path d="M19 21v-10l-6 -4"></path><path d="M9 9l0 .01"></path><path d="M9 12l0 .01"></path><path d="M9 15l0 .01"></path><path d="M9 18l0 .01"></path>', 8)
    ]), 8, mo));
  }
}), _o = {}, yo = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-briefcase",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function xo(n, t) {
  return a(), l("svg", yo, t[0] || (t[0] = [
    z('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M3 7m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"></path><path d="M8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2"></path><path d="M12 12l0 .01"></path><path d="M3 13a20 20 0 0 0 18 0"></path>', 5)
  ]));
}
const s1 = /* @__PURE__ */ T(_o, [["render", xo]]), Co = ["width", "height"], ko = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-download",
  props: {
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" }, null, -1),
      o("path", { d: "M7 11l5 5l5 -5" }, null, -1),
      o("path", { d: "M12 4l0 12" }, null, -1)
    ]), 8, Co));
  }
}), $o = ["width", "height"], n1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-world-up",
  props: {
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      z('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M20.985 12.52a9 9 0 1 0 -8.451 8.463"></path><path d="M3.6 9h16.8"></path><path d="M3.6 15h10.9"></path><path d="M11.5 3a17 17 0 0 0 0 18"></path><path d="M12.5 3a16.996 16.996 0 0 1 2.391 11.512"></path><path d="M19 22v-6"></path><path d="M22 19l-3 -3l-3 3"></path>', 8)
    ]), 8, $o));
  }
}), Mo = ["width", "height"], Bo = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-file",
  props: {
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M14 3v4a1 1 0 0 0 1 1h4" }, null, -1),
      o("path", { d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" }, null, -1)
    ]), 8, Mo));
  }
}), Lo = ["width", "height"], ot = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-chevron-down",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-chevron-down",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M6 9l6 6l6 -6" }, null, -1)
    ]), 8, Lo));
  }
}), Ho = ["width", "height"], Io = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-edit",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-edit",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" }, null, -1),
      o("path", { d: "M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" }, null, -1),
      o("path", { d: "M16 5l3 3" }, null, -1)
    ]), 8, Ho));
  }
}), zo = ["width", "height"], a1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-edit-circle",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-edit-circle",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M12 15l8.385 -8.415a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3z" }, null, -1),
      o("path", { d: "M16 5l3 3" }, null, -1),
      o("path", { d: "M9 7.07a7 7 0 0 0 1 13.93a7 7 0 0 0 6.929 -6" }, null, -1)
    ]), 8, zo));
  }
}), Vo = ["width", "height"], To = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-icon-eye",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-eye",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" }, null, -1),
      o("path", { d: "M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" }, null, -1)
    ]), 8, Vo));
  }
}), So = {}, jo = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-history",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function Zo(n, t) {
  return a(), l("svg", jo, t[0] || (t[0] = [
    o("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null, -1),
    o("path", { d: "M12 8l0 4l2 2" }, null, -1),
    o("path", { d: "M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5" }, null, -1)
  ]));
}
const l1 = /* @__PURE__ */ T(So, [["render", Zo]]), Do = {}, Ao = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-arrow-fork",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function Po(n, t) {
  return a(), l("svg", Ao, t[0] || (t[0] = [
    z('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M16 3h5v5"></path><path d="M8 3h-5v5"></path><path d="M21 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93"></path><path d="M3 3l7.536 7.536a5 5 0 0 1 1.464 3.534v.93"></path>', 5)
  ]));
}
const r1 = /* @__PURE__ */ T(Do, [["render", Po]]), Eo = {}, No = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-arrow-fork tw-rotate-90",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function Oo(n, t) {
  return a(), l("svg", No, t[0] || (t[0] = [
    z('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M16 3h5v5"></path><path d="M8 3h-5v5"></path><path d="M21 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93"></path><path d="M3 3l7.536 7.536a5 5 0 0 1 1.464 3.534v.93"></path>', 5)
  ]));
}
const i1 = /* @__PURE__ */ T(Eo, [["render", Oo]]), Fo = {}, Ro = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-report-analytics",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function Uo(n, t) {
  return a(), l("svg", Ro, t[0] || (t[0] = [
    z('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"></path><path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path><path d="M9 17v-5"></path><path d="M12 17v-1"></path><path d="M15 17v-3"></path>', 6)
  ]));
}
const d1 = /* @__PURE__ */ T(Fo, [["render", Uo]]), Wo = {}, Go = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-shield-check",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function Qo(n, t) {
  return a(), l("svg", Go, t[0] || (t[0] = [
    o("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null, -1),
    o("path", { d: "M11.46 20.846a12 12 0 0 1 -7.96 -14.846a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.09 7.06" }, null, -1),
    o("path", { d: "M15 19l2 2l4 -4" }, null, -1)
  ]));
}
const w1 = /* @__PURE__ */ T(Wo, [["render", Qo]]), Ko = {}, qo = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-shield-lock",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function Jo(n, t) {
  return a(), l("svg", qo, t[0] || (t[0] = [
    o("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none"
    }, null, -1),
    o("path", { d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3" }, null, -1),
    o("path", { d: "M12 11m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" }, null, -1),
    o("path", { d: "M12 12l0 2.5" }, null, -1)
  ]));
}
const c1 = /* @__PURE__ */ T(Ko, [["render", Jo]]), Xo = ["width", "height"], Yo = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-table",
  props: {
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-table",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "#353A3F",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z" }, null, -1),
      o("path", { d: "M3 10h18" }, null, -1),
      o("path", { d: "M10 3v18" }, null, -1)
    ]), 8, Xo));
  }
}), ts = ["width", "height"], es = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-trash",
  props: {
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-trash",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      z('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M4 7l16 0"></path><path d="M10 11l0 6"></path><path d="M14 11l0 6"></path><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>', 6)
    ]), 8, ts));
  }
}), os = ["width", "height"], ss = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-dots-vertical",
  props: {
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-dots-vertical",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" }, null, -1),
      o("path", { d: "M12 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" }, null, -1),
      o("path", { d: "M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" }, null, -1)
    ]), 8, os));
  }
}), ns = ["width", "height"], as = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-arrow-down",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-arrow-down",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M12 5l0 14" }, null, -1),
      o("path", { d: "M18 13l-6 6" }, null, -1),
      o("path", { d: "M6 13l6 6" }, null, -1)
    ]), 8, ns));
  }
}), ls = ["width", "height"], rs = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-arrow-up",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-arrow-up",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M12 5l0 14" }, null, -1),
      o("path", { d: "M18 11l-6 -6" }, null, -1),
      o("path", { d: "M6 11l6 -6" }, null, -1)
    ]), 8, ls));
  }
}), is = ["width", "height"], ds = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-chevron-left",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-chevron-left",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M15 6l-6 6l6 6" }, null, -1)
    ]), 8, is));
  }
}), ws = ["width", "height"], Lt = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-chevron-right",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-chevron-right",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M9 6l6 6l-6 6" }, null, -1)
    ]), 8, ws));
  }
}), cs = ["width", "height"], Ht = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-info-circle",
  props: {
    width: { default: 24 },
    height: { default: 24 }
  },
  setup(n) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-info-circle",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, e[0] || (e[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" }, null, -1),
      o("path", { d: "M12 9h.01" }, null, -1),
      o("path", { d: "M11 12h1v4h1" }, null, -1)
    ]), 8, cs));
  }
}), us = ["width", "height"], u1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-mail",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-mail",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z" }, null, -1),
      o("path", { d: "M3 7l9 6l9 -6" }, null, -1)
    ]), 8, us));
  }
}), hs = ["width", "height"], It = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-x",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-x",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, e[0] || (e[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M18 6l-12 12" }, null, -1),
      o("path", { d: "M6 6l12 12" }, null, -1)
    ]), 8, hs));
  }
}), ps = ["width", "height"], fs = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-user",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-user",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" }, null, -1),
      o("path", { d: "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" }, null, -1)
    ]), 8, ps));
  }
}), gs = ["width", "height"], h1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-logout",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-logout",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" }, null, -1),
      o("path", { d: "M9 12h12l-3 -3" }, null, -1),
      o("path", { d: "M18 15l3 -3" }, null, -1)
    ]), 8, gs));
  }
}), bs = ["width", "height"], vs = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-circle-check",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-circle-check",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" }, null, -1),
      o("path", { d: "M9 12l2 2l4 -4" }, null, -1)
    ]), 8, bs));
  }
}), ms = ["width", "height"], p1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-lifebuoy",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-lifebuoy",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, e[0] || (e[0] = [
      z('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"></path><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path><path d="M15 15l3.35 3.35"></path><path d="M9 15l-3.35 3.35"></path><path d="M5.65 5.65l3.35 3.35"></path><path d="M18.35 5.65l-3.35 3.35"></path>', 7)
    ]), 8, ms));
  }
}), _s = ["width", "height"], f1 = /* @__PURE__ */ c({
  __name: "cl-icon-envelope-at",
  props: {
    width: { default: "75px" },
    height: { default: "75px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      width: t.width,
      height: t.height,
      viewBox: "0 0 94 94",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, s[0] || (s[0] = [
      o("ellipse", {
        cx: "46.334",
        cy: "46.6492",
        rx: "46.334",
        ry: "46.6492",
        transform: "matrix(1 0 0 -1 0.666016 93.2969)",
        fill: "#F7F7F7"
      }, null, -1),
      o("path", {
        d: "M52.8131 47.926L52.0743 46.1004C40.9919 49.9451 34.4793 43.645 34.4793 36.7182C34.4793 29.3716 40.2021 23.8311 47.7908 23.8311C53.9491 23.8311 58.4173 27.8694 58.4173 33.4326C58.4173 38.8559 54.3481 40.3196 52.3844 40.7099V28.095C41.0474 27.7748 38.9602 35.4467 38.9602 37.8019C38.9602 41.0875 41.1741 43.2951 44.4698 43.2951C47.2064 43.2951 49.1467 41.6283 50.4151 39.9225V42.8608C50.4151 42.8608 60.3879 42.8734 60.3879 33.432C60.3879 26.7271 55.0907 21.8604 47.7914 21.8604C38.3512 21.8604 32.51 29.1352 32.51 36.7176C32.5094 43.2579 38.2245 52.548 52.8131 47.926ZM50.4145 35.8287C50.0904 36.6968 48.1873 41.3258 44.4692 41.3258C41.8594 41.3258 40.9295 39.5058 40.9295 37.8025C40.9295 36.0317 42.4444 30.6248 50.4138 30.0934L50.4145 35.8287ZM68.677 27.7641V16.521H54.5908L46.6838 10.0859L38.7767 16.521H24.6906V27.7641L15.1641 35.3685V73.1159H76.4302L76.4447 73.1254L76.451 73.1159H78.2035V35.3685L68.677 27.7641ZM46.6838 12.6081L51.4225 16.5204H41.9451L46.6838 12.6081ZM26.6606 18.491H66.7064V44.0642L52.3706 55.5267L46.6838 51.9202L40.9964 55.5267L26.6606 44.0636V18.491ZM24.6906 30.3178V42.4882L17.0805 36.403L24.6906 30.3178ZM17.134 38.9681L39.2369 56.6424L17.134 70.6593V38.9681ZM20.0439 71.1459L46.6838 54.2533L73.3236 71.1459H20.0439ZM76.2335 70.6593L54.1306 56.6431L76.2341 38.9687L76.2335 70.6593ZM68.677 42.4882V30.3178L76.2877 36.403L68.677 42.4882Z",
        fill: "#B8B8B9"
      }, null, -1)
    ]), 8, _s));
  }
}), ys = ["width", "height"], g1 = /* @__PURE__ */ c({
  __name: "cl-icon-envelope-letter",
  props: {
    width: { default: "75px" },
    height: { default: "75px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      width: t.width,
      height: t.height,
      viewBox: "0 0 94 94",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, s[0] || (s[0] = [
      o("ellipse", {
        cx: "46.334",
        cy: "46.6492",
        rx: "46.334",
        ry: "46.6492",
        transform: "matrix(1 0 0 -1 0.666016 93.2969)",
        fill: "#F7F7F7"
      }, null, -1),
      o("path", {
        d: "M52.8131 47.926L52.0743 46.1004C40.9919 49.9451 34.4793 43.645 34.4793 36.7182C34.4793 29.3716 40.2021 23.8311 47.7908 23.8311C53.9491 23.8311 58.4173 27.8694 58.4173 33.4326C58.4173 38.8559 54.3481 40.3196 52.3844 40.7099V28.095C41.0474 27.7748 38.9602 35.4467 38.9602 37.8019C38.9602 41.0875 41.1741 43.2951 44.4698 43.2951C47.2064 43.2951 49.1467 41.6283 50.4151 39.9225V42.8608C50.4151 42.8608 60.3879 42.8734 60.3879 33.432C60.3879 26.7271 55.0907 21.8604 47.7914 21.8604C38.3512 21.8604 32.51 29.1352 32.51 36.7176C32.5094 43.2579 38.2245 52.548 52.8131 47.926ZM50.4145 35.8287C50.0904 36.6968 48.1873 41.3258 44.4692 41.3258C41.8594 41.3258 40.9295 39.5058 40.9295 37.8025C40.9295 36.0317 42.4444 30.6248 50.4138 30.0934L50.4145 35.8287ZM68.677 27.7641V16.521H54.5908L46.6838 10.0859L38.7767 16.521H24.6906V27.7641L15.1641 35.3685V73.1159H76.4302L76.4447 73.1254L76.451 73.1159H78.2035V35.3685L68.677 27.7641ZM46.6838 12.6081L51.4225 16.5204H41.9451L46.6838 12.6081ZM26.6606 18.491H66.7064V44.0642L52.3706 55.5267L46.6838 51.9202L40.9964 55.5267L26.6606 44.0636V18.491ZM24.6906 30.3178V42.4882L17.0805 36.403L24.6906 30.3178ZM17.134 38.9681L39.2369 56.6424L17.134 70.6593V38.9681ZM20.0439 71.1459L46.6838 54.2533L73.3236 71.1459H20.0439ZM76.2335 70.6593L54.1306 56.6431L76.2341 38.9687L76.2335 70.6593ZM68.677 42.4882V30.3178L76.2877 36.403L68.677 42.4882Z",
        fill: "#B8B8B9"
      }, null, -1)
    ]), 8, ys));
  }
}), xs = ["width", "height"], b1 = /* @__PURE__ */ c({
  __name: "cl-icon-paper-board",
  props: {
    width: { default: "75px" },
    height: { default: "75px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      width: t.width,
      height: t.height,
      viewBox: "0 0 94 94",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, s[0] || (s[0] = [
      z('<ellipse cx="46.1858" cy="46.5" rx="46.1858" ry="46.5" transform="matrix(1 0 0 -1 0.813965 93.6484)" fill="#F7F7F7"></ellipse><path d="M70.8522 48.2649C70.5958 48.2649 70.3499 48.3667 70.1687 48.548C69.9874 48.7293 69.8855 48.9752 69.8855 49.2316V74.3668C69.8855 74.8796 69.6818 75.3713 69.3192 75.7339C68.9566 76.0965 68.4648 76.3002 67.952 76.3002H46.6838C46.171 76.3002 45.6793 76.0965 45.3167 75.7339C44.9541 75.3713 44.7504 74.8796 44.7504 74.3668V40.531C44.7504 40.0182 44.9541 39.5264 45.3167 39.1638C45.6793 38.8012 46.171 38.5975 46.6838 38.5975H61.1849V43.4312C61.1849 44.4568 61.5923 45.4404 62.3175 46.1656C63.0427 46.8907 64.0262 47.2982 65.0518 47.2982H70.8522C71.0434 47.2981 71.2303 47.2414 71.3892 47.1352C71.5482 47.0289 71.672 46.878 71.7452 46.7013C71.8183 46.5247 71.8375 46.3304 71.8002 46.1429C71.7629 45.9554 71.6709 45.7831 71.5357 45.6479L62.8351 36.9473C62.745 36.8585 62.6382 36.7886 62.5209 36.7414C62.4036 36.6943 62.278 36.671 62.1516 36.6728V36.6641H46.6838C45.6583 36.6641 44.6747 37.0715 43.9495 37.7967C43.2243 38.5219 42.8169 39.5054 42.8169 40.531V74.3668C42.8169 75.3923 43.2243 76.3759 43.9495 77.1011C44.6747 77.8263 45.6583 78.2337 46.6838 78.2337H67.952C68.9776 78.2337 69.9612 77.8263 70.6864 77.1011C71.4116 76.3759 71.819 75.3923 71.819 74.3668V49.2316C71.819 48.9752 71.7171 48.7293 71.5358 48.548C71.3545 48.3667 71.1086 48.2649 70.8522 48.2649ZM63.1183 39.9645L68.5185 45.3647H65.0518C64.539 45.3647 64.0472 45.161 63.6846 44.7984C63.3221 44.4358 63.1183 43.944 63.1183 43.4312V39.9645Z" fill="#B8B8B9"></path><path d="M63.1193 53.1053H51.5185C51.2621 53.1053 51.0162 53.0035 50.8349 52.8222C50.6536 52.6409 50.5518 52.395 50.5518 52.1386C50.5518 51.8822 50.6536 51.6363 50.8349 51.455C51.0162 51.2737 51.2621 51.1719 51.5185 51.1719H63.1193C63.3757 51.1719 63.6216 51.2737 63.8029 51.455C63.9842 51.6363 64.0861 51.8822 64.0861 52.1386C64.0861 52.395 63.9842 52.6409 63.8029 52.8222C63.6216 53.0035 63.3757 53.1053 63.1193 53.1053Z" fill="#B8B8B9"></path><path d="M63.1193 57.9374H51.5185C51.2621 57.9374 51.0162 57.8355 50.8349 57.6542C50.6536 57.4729 50.5518 57.227 50.5518 56.9706C50.5518 56.7142 50.6536 56.4684 50.8349 56.2871C51.0162 56.1058 51.2621 56.0039 51.5185 56.0039H63.1193C63.3757 56.0039 63.6216 56.1058 63.8029 56.2871C63.9842 56.4684 64.0861 56.7142 64.0861 56.9706C64.0861 57.227 63.9842 57.4729 63.8029 57.6542C63.6216 57.8355 63.3757 57.9374 63.1193 57.9374Z" fill="#B8B8B9"></path><path d="M63.1193 62.7694H51.5185C51.2621 62.7694 51.0162 62.6676 50.8349 62.4863C50.6536 62.305 50.5518 62.0591 50.5518 61.8027C50.5518 61.5463 50.6536 61.3004 50.8349 61.1191C51.0162 60.9378 51.2621 60.8359 51.5185 60.8359H63.1193C63.3757 60.8359 63.6216 60.9378 63.8029 61.1191C63.9842 61.3004 64.0861 61.5463 64.0861 61.8027C64.0861 62.0591 63.9842 62.305 63.8029 62.4863C63.6216 62.6676 63.3757 62.7694 63.1193 62.7694Z" fill="#B8B8B9"></path><path d="M63.1193 67.6014H51.5185C51.2621 67.6014 51.0162 67.4996 50.8349 67.3183C50.6536 67.137 50.5518 66.8911 50.5518 66.6347C50.5518 66.3783 50.6536 66.1324 50.8349 65.9511C51.0162 65.7698 51.2621 65.668 51.5185 65.668H63.1193C63.3757 65.668 63.6216 65.7698 63.8029 65.9511C63.9842 66.1324 64.0861 66.3783 64.0861 66.6347C64.0861 66.8911 63.9842 67.137 63.8029 67.3183C63.6216 67.4996 63.3757 67.6014 63.1193 67.6014Z" fill="#B8B8B9"></path><path d="M61.1841 35.7062C60.9278 35.7062 60.6819 35.6043 60.5006 35.423C60.3193 35.2417 60.2174 34.9958 60.2174 34.7394V26.0388C60.2174 25.526 60.0137 25.0342 59.6511 24.6716C59.2885 24.3091 58.7967 24.1053 58.2839 24.1053H55.3837C55.1273 24.1053 54.8814 24.0035 54.7001 23.8222C54.5188 23.6409 54.417 23.395 54.417 23.1386C54.417 22.8822 54.5188 22.6363 54.7001 22.455C54.8814 22.2737 55.1273 22.1719 55.3837 22.1719H58.2839C59.3095 22.1719 60.2931 22.5793 61.0183 23.3045C61.7435 24.0297 62.1509 25.0132 62.1509 26.0388V34.7394C62.1509 34.9958 62.049 35.2417 61.8677 35.423C61.6864 35.6043 61.4405 35.7062 61.1841 35.7062Z" fill="#B8B8B9"></path><path d="M52.4849 19.2654H45.5949C45.381 18.4349 44.897 17.6991 44.2191 17.1737C43.5412 16.6484 42.7079 16.3633 41.8503 16.3633C40.9927 16.3633 40.1594 16.6484 39.4815 17.1737C38.8036 17.6991 38.3196 18.4349 38.1056 19.2654H31.2167C30.9603 19.2654 30.7144 19.3673 30.5331 19.5486C30.3518 19.7299 30.2499 19.9758 30.2499 20.2322V22.1656H25.4163C24.3907 22.1656 23.4071 22.573 22.6819 23.2982C21.9567 24.0234 21.5493 25.007 21.5493 26.0326V67.6022C21.5493 68.6278 21.9567 69.6114 22.6819 70.3366C23.4071 71.0618 24.3907 71.4692 25.4163 71.4692H40.884C41.1404 71.4692 41.3863 71.3673 41.5676 71.186C41.7489 71.0047 41.8508 70.7588 41.8508 70.5024C41.8508 70.246 41.7489 70.0001 41.5676 69.8188C41.3863 69.6375 41.1404 69.5357 40.884 69.5357H25.4163C24.9035 69.5357 24.4117 69.332 24.0491 68.9694C23.6865 68.6068 23.4828 68.115 23.4828 67.6022V26.0326C23.4828 25.5198 23.6865 25.028 24.0491 24.6654C24.4117 24.3028 24.9035 24.0991 25.4163 24.0991H30.2499V26.0326C30.2499 26.289 30.3518 26.5349 30.5331 26.7162C30.7144 26.8975 30.9603 26.9993 31.2167 26.9993H52.4849C52.7413 26.9993 52.9872 26.8975 53.1685 26.7162C53.3498 26.5349 53.4516 26.289 53.4516 26.0326V20.2322C53.4516 19.9758 53.3498 19.7299 53.1685 19.5486C52.9872 19.3673 52.7413 19.2654 52.4849 19.2654ZM51.5181 25.0658H32.1834V21.1989H38.9506C39.207 21.1989 39.4529 21.097 39.6342 20.9157C39.8154 20.7344 39.9173 20.4886 39.9173 20.2322C39.9173 19.7194 40.121 19.2276 40.4836 18.865C40.8462 18.5024 41.338 18.2987 41.8508 18.2987C42.3636 18.2987 42.8553 18.5024 43.2179 18.865C43.5805 19.2276 43.7842 19.7194 43.7842 20.2322C43.7842 20.4886 43.8861 20.7344 44.0674 20.9157C44.2487 21.097 44.4946 21.1989 44.751 21.1989H51.5181V25.0658Z" fill="#B8B8B9"></path>', 8)
    ]), 8, xs));
  }
}), Cs = ["width", "height"], v1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-copy",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-copy",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M8 8m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z" }, null, -1),
      o("path", { d: "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2" }, null, -1)
    ]), 8, Cs));
  }
}), ks = ["width", "height"], m1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-info-filled",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-info-circle-filled",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", {
        d: "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
        "stroke-width": "0",
        fill: "currentColor"
      }, null, -1)
    ]), 8, ks));
  }
}), $s = ["width", "height"], _1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-calendar-event",
  props: {
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(n) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-calendar-event",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, e[0] || (e[0] = [
      z('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M4 5m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"></path><path d="M16 3l0 4"></path><path d="M8 3l0 4"></path><path d="M4 11l16 0"></path><path d="M8 15h2v2h-2z"></path>', 6)
    ]), 8, $s));
  }
}), Ms = ["width", "height"], y1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-alert-triangle",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-alert-triangle",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M12 9v4" }, null, -1),
      o("path", { d: "M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z" }, null, -1),
      o("path", { d: "M12 16h.01" }, null, -1)
    ]), 8, Ms));
  }
}), Bs = ["width", "height"], Ls = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-circle-check-filled",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-circle-check-filled",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", {
        d: "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z",
        "stroke-width": "0",
        fill: "#00BAA0"
      }, null, -1)
    ]), 8, Bs));
  }
}), Hs = ["width", "height"], x1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-adjustments-horizontal",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-adjustments-horizontal",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, e[0] || (e[0] = [
      z('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M14 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path><path d="M4 6l8 0"></path><path d="M16 6l4 0"></path><path d="M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path><path d="M4 12l2 0"></path><path d="M10 12l10 0"></path><path d="M17 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path><path d="M4 18l11 0"></path><path d="M19 18l1 0"></path>', 10)
    ]), 8, Hs));
  }
}), Is = ["width", "height"], C1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-mail-check",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-mail-check",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, e[0] || (e[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6" }, null, -1),
      o("path", { d: "M3 7l9 6l9 -6" }, null, -1),
      o("path", { d: "M15 19l2 2l4 -4" }, null, -1)
    ]), 8, Is));
  }
}), zs = ["width", "height"], k1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-forbid",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-forbid",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, e[0] || (e[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" }, null, -1),
      o("path", { d: "M9 9l6 6" }, null, -1)
    ]), 8, zs));
  }
}), Vs = ["width", "height"], $1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-user-plus",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-user-plus",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, e[0] || (e[0] = [
      z('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path><path d="M16 19h6"></path><path d="M19 16v6"></path><path d="M6 21v-2a4 4 0 0 1 4 -4h4"></path>', 5)
    ]), 8, Vs));
  }
}), Ts = ["width", "height"], zt = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-search",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-search",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" }, null, -1),
      o("path", { d: "M21 21l-6 -6" }, null, -1)
    ]), 8, Ts));
  }
}), Ss = ["width", "height"], M1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-fish-hook",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-fish-hook",
      viewBox: "0 0 24 24",
      "stroke-width": "2",
      width: t.width,
      height: t.height,
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M16 9v6a5 5 0 0 1 -10 0v-4l3 3" }, null, -1),
      o("path", { d: "M16 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" }, null, -1),
      o("path", { d: "M16 5v-2" }, null, -1)
    ]), 8, Ss));
  }
}), js = ["width", "height"], B1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-school",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-school",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "1.5",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M22 9l-10 -4l-10 4l10 4l10 -4v6" }, null, -1),
      o("path", { d: "M6 10.6v5.4a6 3 0 0 0 12 0v-5.4" }, null, -1)
    ]), 8, js));
  }
}), Zs = ["width", "height"], L1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-archive",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-archive",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "1.5",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M3 4m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z" }, null, -1),
      o("path", { d: "M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10" }, null, -1),
      o("path", { d: "M10 12l4 0" }, null, -1)
    ]), 8, Zs));
  }
}), Ds = ["width", "height"], H1 = /* @__PURE__ */ c({
  __name: "cl-icon-table-check",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "icon icon-tabler icon-tabler-check",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      "stroke-width": "1.5",
      stroke: "currentColor",
      fill: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, s[0] || (s[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M5 12l5 5l10 -10" }, null, -1)
    ]), 8, Ds));
  }
}), As = ["width", "height"], I1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-world-check",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "icon icon-tabler icons-tabler-outline icon-tabler-world-check"
    }, e[0] || (e[0] = [
      z('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M20.946 12.99a9 9 0 1 0 -9.46 7.995"></path><path d="M3.6 9h16.8"></path><path d="M3.6 15h13.9"></path><path d="M11.5 3a17 17 0 0 0 0 18"></path><path d="M12.5 3a16.997 16.997 0 0 1 2.311 12.001"></path><path d="M15 19l2 2l4 -4"></path>', 7)
    ]), 8, As));
  }
}), Ps = ["width", "height"], z1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-external-link",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "icon icon-tabler icon-tabler-external-link"
    }, e[0] || (e[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6" }, null, -1),
      o("path", { d: "M11 13l9 -9" }, null, -1),
      o("path", { d: "M15 4h5v5" }, null, -1)
    ]), 8, Ps));
  }
}), Es = ["width", "height"], V1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-file-type-pdf",
  props: {
    width: { default: "16px" },
    height: { default: "16px" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "icon icon-tabler icons-tabler-outline icon-tabler-file-type-pdf"
    }, s[0] || (s[0] = [
      z('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M14 3v4a1 1 0 0 0 1 1h4"></path><path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"></path><path d="M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6"></path><path d="M17 18h2"></path><path d="M20 15h-3v6"></path><path d="M11 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"></path>', 7)
    ]), 8, Es));
  }
}), Ns = ["width", "height"], T1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-sparkles",
  props: {
    width: { default: 24 },
    height: { default: 24 }
  },
  setup(n) {
    return (t, e) => (a(), l("svg", {
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, e[0] || (e[0] = [
      o("path", {
        d: "M16 18C16.5304 18 17.0391 18.2107 17.4142 18.5858C17.7893 18.9609 18 19.4696 18 20C18 19.4696 18.2107 18.9609 18.5858 18.5858C18.9609 18.2107 19.4696 18 20 18C19.4696 18 18.9609 17.7893 18.5858 17.4142C18.2107 17.0391 18 16.5304 18 16C18 16.5304 17.7893 17.0391 17.4142 17.4142C17.0391 17.7893 16.5304 18 16 18ZM16 6C16.5304 6 17.0391 6.21071 17.4142 6.58579C17.7893 6.96086 18 7.46957 18 8C18 7.46957 18.2107 6.96086 18.5858 6.58579C18.9609 6.21071 19.4696 6 20 6C19.4696 6 18.9609 5.78929 18.5858 5.41421C18.2107 5.03914 18 4.53043 18 4C18 4.53043 17.7893 5.03914 17.4142 5.41421C17.0391 5.78929 16.5304 6 16 6ZM9 18C9 16.4087 9.63214 14.8826 10.7574 13.7574C11.8826 12.6321 13.4087 12 15 12C13.4087 12 11.8826 11.3679 10.7574 10.2426C9.63214 9.11742 9 7.5913 9 6C9 7.5913 8.36786 9.11742 7.24264 10.2426C6.11742 11.3679 4.5913 12 3 12C4.5913 12 6.11742 12.6321 7.24264 13.7574C8.36786 14.8826 9 16.4087 9 18Z",
        fill: "currentColor",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ]), 8, Ns));
  }
}), Os = ["width", "height"], S1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-sparkles-horizontal",
  props: {
    width: { default: 24 },
    height: { default: 24 }
  },
  setup(n) {
    return (t, e) => (a(), l("svg", {
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: "tw-scale-x-[-1]"
    }, e[0] || (e[0] = [
      o("path", {
        d: "M16 18C16.5304 18 17.0391 18.2107 17.4142 18.5858C17.7893 18.9609 18 19.4696 18 20C18 19.4696 18.2107 18.9609 18.5858 18.5858C18.9609 18.2107 19.4696 18 20 18C19.4696 18 18.9609 17.7893 18.5858 17.4142C18.2107 17.0391 18 16.5304 18 16C18 16.5304 17.7893 17.0391 17.4142 17.4142C17.0391 17.7893 16.5304 18 16 18ZM16 6C16.5304 6 17.0391 6.21071 17.4142 6.58579C17.7893 6.96086 18 7.46957 18 8C18 7.46957 18.2107 6.96086 18.5858 6.58579C18.9609 6.21071 19.4696 6 20 6C19.4696 6 18.9609 5.78929 18.5858 5.41421C18.2107 5.03914 18 4.53043 18 4C18 4.53043 17.7893 5.03914 17.4142 5.41421C17.0391 5.78929 16.5304 6 16 6ZM9 18C9 16.4087 9.63214 14.8826 10.7574 13.7574C11.8826 12.6321 13.4087 12 15 12C13.4087 12 11.8826 11.3679 10.7574 10.2426C9.63214 9.11742 9 7.5913 9 6C9 7.5913 8.36786 9.11742 7.24264 10.2426C6.11742 11.3679 4.5913 12 3 12C4.5913 12 6.11742 12.6321 7.24264 13.7574C8.36786 14.8826 9 16.4087 9 18Z",
        fill: "currentColor",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ]), 8, Os));
  }
}), Fs = ["width", "height"], j1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-zoom-exclamation",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "icon icon-tabler icons-tabler-outline icon-tabler-zoom-exclamation"
    }, e[0] || (e[0] = [
      z('<path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path><path d="M21 21l-6 -6"></path><path d="M10 13v.01"></path><path d="M10 7v3"></path>', 5)
    ]), 8, Fs));
  }
}), Rs = ["width", "height"], Z1 = /* @__PURE__ */ c({
  __name: "cl-icon-tabler-alert-circle-filled",
  props: {
    width: { default: "24px" },
    height: { default: "24px" }
  },
  setup(n) {
    return (t, e) => (a(), l("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: t.width,
      height: t.height,
      viewBox: "0 0 24 24",
      fill: "currentColor",
      class: "icon icon-tabler icons-tabler-filled icon-tabler-alert-circle"
    }, e[0] || (e[0] = [
      o("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
      }, null, -1),
      o("path", { d: "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm.01 13l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z" }, null, -1)
    ]), 8, Rs));
  }
}), Us = {}, Ws = {
  width: "216",
  height: "162",
  viewBox: "0 0 216 162",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Gs(n, t) {
  return a(), l("svg", Ws, t[0] || (t[0] = [
    z('<g clip-path="url(#clip0_1774_2384)"><path fill-rule="evenodd" clip-rule="evenodd" d="M199.279 125.167C201.047 122.903 202 120.496 202 118C202 104.745 175.137 94 142 94C111.689 94 86.6271 102.991 82.5733 114.669C35.1959 117.21 0 126.691 0 138C0 151.255 48.3532 162 108 162C167.647 162 216 151.255 216 138C216 133.28 209.869 128.878 199.279 125.167Z" fill="#E7E8E9"></path><path d="M38 58H128.219L128 138H38V58Z" fill="#DBF0EB"></path><path d="M128.219 58H178V138H128L128.219 58Z" fill="#BBE2DA"></path><path d="M38 58L24 28H82.0803L97 58H38Z" fill="#2F6F61"></path><path d="M178 58L192.219 28H142.219L128.219 58H178Z" fill="#DBF0EB"></path><path d="M73 58H97V86H73V58Z" fill="#53B7A1"></path><path d="M131.645 12.8189C131.962 12.3664 131.852 11.7429 131.399 11.4261C130.947 11.1093 130.324 11.2193 130.007 11.6717L119.682 26.4164C119.366 26.8688 119.476 27.4924 119.928 27.8092C120.38 28.1259 121.004 28.016 121.321 27.5636L131.645 12.8189Z" fill="#97D3C6"></path><path d="M88.5735 12.8188C88.2567 12.3664 88.3667 11.7428 88.8191 11.4261C89.2715 11.1093 89.895 11.2192 90.2118 11.6716L100.536 26.4164C100.853 26.8688 100.743 27.4923 100.291 27.8091C99.8382 28.1259 99.2147 28.0159 98.8979 27.5635L88.5735 12.8188Z" fill="#97D3C6"></path><path d="M109.109 1C109.109 0.447715 109.557 0 110.109 0C110.661 0 111.109 0.447715 111.109 1V27C111.109 27.5523 110.661 28 110.109 28C109.557 28 109.109 27.5523 109.109 27V1Z" fill="#97D3C6"></path></g>', 1)
  ]));
}
const D1 = /* @__PURE__ */ T(Us, [["render", Gs]]), Qs = {}, Ks = {
  width: "216",
  height: "162",
  viewBox: "0 0 216 162",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function qs(n, t) {
  return a(), l("svg", Ks, t[0] || (t[0] = [
    z('<g clip-path="url(#clip0_83_1053)"><path d="M178 50.9522C205.43 63.4844 194.054 112.102 153.46 139.209C112.866 166.315 18.2443 141.792 12.9565 109.891C14.8138 83.7692 75.2261 101.415 108.957 78.8914C149.551 51.7849 150.569 38.4199 178 50.9522Z" fill="#E7E8E9"></path><path d="M78.8269 33.8543H137.957V23.3975H79.7157C79.1499 23.3975 78.6105 23.1578 78.2313 22.7379L70.8392 14.551C70.46 14.1311 69.9206 13.8914 69.3548 13.8914H36.9565C35.852 13.8914 34.9565 14.7868 34.9565 15.8914V33.8543H52.6001H70.2436H78.8269Z" fill="#BBE2DA"></path><path d="M34.9565 88.8914C34.9565 89.9959 35.852 90.8914 36.9565 90.8914H135.957C137.061 90.8914 137.957 89.9959 137.957 88.8914V62.3728V51.916V33.8543H78.8269H70.2436H52.6001H34.9565V88.8914Z" fill="#BBE2DA"></path><path d="M34.9565 33.8543V88.8914C34.9565 89.9959 35.852 90.8914 36.9565 90.8914H135.957C137.061 90.8914 137.957 89.9959 137.957 88.8914V62.3728M34.9565 33.8543V15.8914C34.9565 14.7868 35.852 13.8914 36.9565 13.8914H69.3548C69.9206 13.8914 70.46 14.1311 70.8392 14.551L78.2313 22.7379C78.6105 23.1578 79.1499 23.3975 79.7157 23.3975H137.957M34.9565 33.8543H52.6001H70.2436H78.8269H137.957M137.957 33.8543V62.3728M137.957 33.8543V23.3975M137.957 33.8543V51.916M137.957 62.3728V51.916M137.957 23.3975V51.916M40.6788 44.3111H58.3223H67.144H75.9658H82.1649H88.364M40.6788 50.9654H58.3223H67.144H75.9658" stroke="#97D3C6" stroke-width="3"></path><ellipse cx="21.104" cy="21.1152" rx="21.104" ry="21.1152" transform="matrix(0.66145 -0.74999 0.75267 0.658398 104 83.6558)" fill="#DBF0EB" stroke="#3F9784" stroke-width="3"></ellipse><mask id="path-5-inside-1_83_1053" fill="white"><path fill-rule="evenodd" clip-rule="evenodd" d="M148.661 95.7164C148.296 96.1306 148.337 96.7612 148.753 97.1248L152.643 100.528L150.99 102.402C150.624 102.817 150.665 103.447 151.081 103.811L180.268 129.342C180.683 129.706 181.317 129.665 181.682 129.25L187.339 122.836C187.704 122.422 187.663 121.792 187.247 121.428L158.06 95.8968C157.645 95.5332 157.012 95.5742 156.646 95.9884L154.969 97.8898L151.079 94.4868C150.663 94.1232 150.03 94.1642 149.665 94.5784L148.661 95.7164Z"></path></mask><path fill-rule="evenodd" clip-rule="evenodd" d="M148.661 95.7164C148.296 96.1306 148.337 96.7612 148.753 97.1248L152.643 100.528L150.99 102.402C150.624 102.817 150.665 103.447 151.081 103.811L180.268 129.342C180.683 129.706 181.317 129.665 181.682 129.25L187.339 122.836C187.704 122.422 187.663 121.792 187.247 121.428L158.06 95.8968C157.645 95.5332 157.012 95.5742 156.646 95.9884L154.969 97.8898L151.079 94.4868C150.663 94.1232 150.03 94.1642 149.665 94.5784L148.661 95.7164Z" fill="#3F9784"></path><path d="M148.753 97.1248L148.091 97.8748L148.753 97.1248ZM148.661 95.7164L149.414 96.3748L148.661 95.7164ZM152.643 100.528L153.396 101.186L154.057 100.436L153.304 99.7778L152.643 100.528ZM150.99 102.402L151.742 103.061L150.99 102.402ZM151.081 103.811L151.742 103.061L151.081 103.811ZM180.268 129.342L179.606 130.092L180.268 129.342ZM187.247 121.428L187.909 120.678L187.247 121.428ZM158.06 95.8968L157.399 96.6468L158.06 95.8968ZM154.969 97.8898L154.308 98.6398L155.061 99.2982L155.722 98.5482L154.969 97.8898ZM149.665 94.5784L148.912 93.92L149.665 94.5784ZM149.414 96.3748L149.414 96.3748L147.909 95.058C147.178 95.8864 147.26 97.1475 148.091 97.8748L149.414 96.3748ZM153.304 99.7778L149.414 96.3748L148.091 97.8748L151.981 101.278L153.304 99.7778ZM151.742 103.061L153.396 101.186L151.89 99.8694L150.237 101.744L151.742 103.061ZM151.742 103.061L151.742 103.061L150.237 101.744C149.506 102.572 149.588 103.833 150.419 104.561L151.742 103.061ZM180.929 128.592L151.742 103.061L150.419 104.561L179.606 130.092L180.929 128.592ZM180.929 128.592L180.929 128.592L179.606 130.092C180.438 130.819 181.704 130.737 182.435 129.909L180.929 128.592ZM186.586 122.178L180.929 128.592L182.435 129.909L188.091 123.495L186.586 122.178ZM186.586 122.178L186.586 122.178L188.091 123.495C188.822 122.666 188.74 121.405 187.909 120.678L186.586 122.178ZM157.399 96.6468L186.586 122.178L187.909 120.678L158.722 95.1468L157.399 96.6468ZM157.399 96.6468L157.399 96.6468L158.722 95.1468C157.891 94.4196 156.624 94.5016 155.894 95.33L157.399 96.6468ZM155.722 98.5482L157.399 96.6468L155.894 95.33L154.217 97.2314L155.722 98.5482ZM150.418 95.2368L154.308 98.6398L155.631 97.1398L151.741 93.7368L150.418 95.2368ZM150.418 95.2368L150.418 95.2368L151.741 93.7368C150.909 93.0096 149.643 93.0916 148.912 93.92L150.418 95.2368ZM149.414 96.3748L150.418 95.2368L148.912 93.92L147.909 95.058L149.414 96.3748Z" fill="#3F9784" mask="url(#path-5-inside-1_83_1053)"></path></g>', 1)
  ]));
}
const A1 = /* @__PURE__ */ T(Qs, [["render", qs]]), Js = {}, Xs = {
  width: "216",
  height: "162",
  viewBox: "0 0 216 162",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Ys(n, t) {
  return a(), l("svg", Xs, t[0] || (t[0] = [
    z('<path fill-rule="evenodd" clip-rule="evenodd" d="M123.229 102.237C112.962 97.1895 97.8503 94 81 94C56.8024 94 36.1894 100.577 28.3639 109.788C10.7495 114.059 0 119.75 0 126C0 139.255 48.3532 150 108 150C167.647 150 216 139.255 216 126C216 113.894 175.664 103.881 123.229 102.237Z" fill="#E7E8E9"></path><path d="M156.753 39.7579L75.9397 69.1717C75.4207 69.3606 75.1531 69.9344 75.342 70.4534L92.443 117.438C92.6319 117.957 93.2058 118.225 93.7247 118.036L174.538 88.622C175.057 88.4331 175.325 87.8592 175.136 87.3403L158.035 40.3556C157.846 39.8366 157.272 39.5691 156.753 39.7579Z" fill="#97D3C6"></path><path d="M75 69.5137L126.404 83.7957C126.815 83.91 127.254 83.7503 127.496 83.3982L157.693 39.4159L175.136 87.3402C175.325 87.8592 175.057 88.433 174.538 88.6219L93.7247 118.036C93.2058 118.225 92.6319 117.957 92.443 117.438L75 69.5137Z" fill="#97D3C6"></path><path d="M75 69.5137L92.443 117.438C92.6319 117.957 93.2058 118.225 93.7247 118.036L174.538 88.6219C175.057 88.433 175.325 87.8592 175.136 87.3402L157.693 39.4159M75 69.5137L126.404 83.7957C126.815 83.91 127.254 83.7503 127.496 83.3982L157.693 39.4159M75 69.5137C141.154 45.4355 154.163 40.7005 157.693 39.4159" stroke="#BBE2DA" stroke-width="2" stroke-linejoin="round"></path><path d="M173.554 38.035C170.532 29.7314 161.351 25.45 153.047 28.4723C144.743 31.4946 140.462 40.676 143.484 48.9797C146.507 57.2833 155.688 61.5647 163.992 58.5425C172.295 55.5202 176.577 46.3387 173.554 38.035Z" fill="#53B7A1"></path><path d="M161.007 50.3459C159.908 50.7459 158.864 50.8111 157.874 50.5416C156.887 50.266 155.99 49.6779 155.183 48.7772C154.38 47.8705 153.707 46.6719 153.164 45.1814C152.626 43.6892 152.376 42.3443 152.414 41.1465C152.454 39.9426 152.766 38.9223 153.348 38.0855C153.935 37.2472 154.775 36.6288 155.87 36.2305C156.964 35.8321 158.006 35.7654 158.994 36.0305C159.982 36.2956 160.877 36.877 161.677 37.7748C162.482 38.671 163.155 39.8622 163.696 41.3482C164.24 42.8432 164.493 44.1971 164.456 45.4098C164.422 46.6165 164.112 47.6413 163.527 48.4841C162.946 49.3253 162.106 49.9459 161.007 50.3459ZM160.247 48.2569C161.101 47.946 161.622 47.2802 161.81 46.2595C162.001 45.2328 161.797 43.8985 161.2 42.2567C160.805 41.1711 160.359 40.3003 159.863 39.6443C159.368 38.9883 158.845 38.5487 158.295 38.3256C157.744 38.098 157.185 38.087 156.62 38.2927C155.77 38.602 155.252 39.2692 155.066 40.2943C154.878 41.315 155.079 42.6404 155.667 44.2705C156.059 45.3622 156.502 46.239 156.995 46.9011C157.492 47.5615 158.017 48.0056 158.568 48.2331C159.118 48.4563 159.677 48.4642 160.247 48.2569Z" fill="white"></path><path d="M67.0009 23.2526L36.2209 57.4372C35.8514 57.8477 35.8845 58.48 36.2949 58.8495L55.6167 76.2469C56.0271 76.6165 56.6594 76.5833 57.029 76.1729L87.809 41.9882C88.1785 41.5778 88.1454 40.9455 87.735 40.576L68.4132 23.1786C68.0028 22.809 67.3705 22.8422 67.0009 23.2526Z" fill="#97D3C6"></path><path d="M35.5518 58.1804L63.4951 51.8208C63.9073 51.727 64.2159 51.3842 64.2661 50.9645L67.67 22.5095L87.7349 40.576C88.1454 40.9455 88.1785 41.5778 87.8089 41.9883L57.0289 76.1729C56.6594 76.5834 56.0271 76.6165 55.6167 76.2469L35.5518 58.1804Z" fill="#97D3C6"></path><path d="M35.5518 58.1804L55.6167 76.2469C56.0271 76.6165 56.6594 76.5834 57.0289 76.1729L87.8089 41.9883C88.1785 41.5778 88.1454 40.9455 87.7349 40.576L67.67 22.5095M35.5518 58.1804L63.4951 51.8208C63.9073 51.727 64.2159 51.3842 64.2661 50.9645L67.67 22.5095M35.5518 58.1804C61.2464 29.6437 66.2991 24.032 67.67 22.5095" stroke="#BBE2DA" stroke-width="2" stroke-linejoin="round"></path>', 9)
  ]));
}
const P1 = /* @__PURE__ */ T(Js, [["render", Ys]]), tn = {}, en = {
  width: "216",
  height: "162",
  viewBox: "0 0 216 162",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function on(n, t) {
  return a(), l("svg", en, t[0] || (t[0] = [
    z('<g clip-path="url(#clip0_1635_22470)"><mask id="mask0_1635_22470" style="mask-type:luminance;" maskUnits="userSpaceOnUse" x="0" y="0" width="216" height="162"><path d="M216 0H0V162H216V0Z" fill="white"></path></mask><g mask="url(#mask0_1635_22470)"><path d="M171.501 8.99934C202.661 23.2356 221.115 105.207 175.001 135.999C128.887 166.791 22.7698 137 11 89.5C1.70804 51.9999 19.8553 32.9445 65.1126 35.7234C122.113 39.2232 140.341 -5.23694 171.501 8.99934Z" fill="#E7E8E9"></path><path d="M24 135H192V47.5V39.5V35H108H24V39.5V47.5V135Z" fill="#DBF0EB"></path><path d="M24 35H108H192V24.5H108H24V35Z" fill="#DBF0EB"></path><path d="M24 35H108H192M24 35V47.5M24 35V39.5M24 35V24.5M192 35V47.5M192 35V39.5M192 35V24.5M24 47.5V135H192V47.5M24 47.5V39.5M24 39.5V24.5M24 24.5H108H192M192 47.5V39.5M192 39.5V24.5" stroke="#97D3C6" stroke-width="3" stroke-linejoin="round"></path><path d="M52 99.6665H40V106.667H52V99.6665Z" fill="#97D3C6"></path><path d="M52 106.667H40V123H52V106.667Z" fill="#53B7A1"></path><path d="M72 81H60V111.333H72V81Z" fill="#97D3C6"></path><path d="M72 111.333H60V123H72V111.333Z" fill="#53B7A1"></path><path d="M92 95H80V104.333H92V95Z" fill="#97D3C6"></path><path d="M92 104.333H80V123H92V104.333Z" fill="#53B7A1"></path><path d="M112 85.6665H100V99.6665H112V85.6665Z" fill="#97D3C6"></path><path d="M112 99.6665H100V123H112V99.6665Z" fill="#53B7A1"></path><path d="M155 107C152.242 107 149.511 106.457 146.964 105.401C144.416 104.346 142.101 102.799 140.151 100.849C138.201 98.8992 136.654 96.5842 135.599 94.0363C134.543 91.4885 134 88.7577 134 86C134 83.2422 134.543 80.5115 135.599 77.9636C136.654 75.4158 138.201 73.1008 140.151 71.1507C142.101 69.2007 144.416 67.6539 146.964 66.5985C149.512 65.5432 152.242 65 155 65V73.4C153.345 73.4 151.707 73.7259 150.178 74.3591C148.649 74.9923 147.26 75.9204 146.09 77.0904C144.92 78.2605 143.992 79.6495 143.359 81.1782C142.726 82.7069 142.4 84.3453 142.4 86C142.4 87.6546 142.726 89.2931 143.359 90.8218C143.992 92.3505 144.92 93.7395 146.09 94.9095C147.26 96.0796 148.649 97.0077 150.178 97.6409C151.707 98.2741 153.345 98.6 155 98.6V107Z" fill="#76C6B5"></path><path d="M155 65C159.435 65 163.756 66.404 167.343 69.0106C170.931 71.6173 173.602 75.2929 174.972 79.5106L166.983 82.1064C166.161 79.5758 164.559 77.3704 162.406 75.8064C160.253 74.2424 157.661 73.4 155 73.4V65Z" fill="#97D3C6"></path><path d="M174.991 79.5684C176.006 82.7232 176.26 86.0734 175.732 89.3451C175.204 92.6168 173.909 95.7171 171.954 98.3926C169.998 101.068 167.437 103.243 164.48 104.739C161.523 106.235 158.253 107.009 154.939 107L154.964 98.5999C156.952 98.6057 158.914 98.1408 160.688 97.2432C162.462 96.3456 163.999 95.0408 165.172 93.4355C166.346 91.8303 167.122 89.9701 167.439 88.007C167.756 86.044 167.604 84.0339 166.995 82.141L174.991 79.5684Z" fill="#53B7A1"></path><path d="M110 47H42C40.8954 47 40 47.8954 40 49C40 50.1046 40.8954 51 42 51H110C111.105 51 112 50.1046 112 49C112 47.8954 111.105 47 110 47Z" fill="#97D3C6"></path><path d="M79 47H42C40.8954 47 40 47.8954 40 49C40 50.1046 40.8954 51 42 51H79C80.1046 51 81 50.1046 81 49C81 47.8954 80.1046 47 79 47Z" fill="#53B7A1"></path><path d="M110 55H42C40.8954 55 40 55.8954 40 57C40 58.1046 40.8954 59 42 59H110C111.105 59 112 58.1046 112 57C112 55.8954 111.105 55 110 55Z" fill="#97D3C6"></path><path d="M100 55H42C40.8954 55 40 55.8954 40 57C40 58.1046 40.8954 59 42 59H100C101.105 59 102 58.1046 102 57C102 55.8954 101.105 55 100 55Z" fill="#53B7A1"></path><path d="M110 63H42C40.8954 63 40 63.8954 40 65C40 66.1046 40.8954 67 42 67H110C111.105 67 112 66.1046 112 65C112 63.8954 111.105 63 110 63Z" fill="#97D3C6"></path><path d="M56 63H42C40.8954 63 40 63.8954 40 65C40 66.1046 40.8954 67 42 67H56C57.1046 67 58 66.1046 58 65C58 63.8954 57.1046 63 56 63Z" fill="#53B7A1"></path><path d="M30 32C31.1046 32 32 31.1046 32 30C32 28.8954 31.1046 28 30 28C28.8954 28 28 28.8954 28 30C28 31.1046 28.8954 32 30 32Z" fill="#97D3C6"></path><path d="M38 32C39.1046 32 40 31.1046 40 30C40 28.8954 39.1046 28 38 28C36.8954 28 36 28.8954 36 30C36 31.1046 36.8954 32 38 32Z" fill="#97D3C6"></path><path d="M46 32C47.1046 32 48 31.1046 48 30C48 28.8954 47.1046 28 46 28C44.8954 28 44 28.8954 44 30C44 31.1046 44.8954 32 46 32Z" fill="#97D3C6"></path></g></g><defs><clipPath id="clip0_1635_22470"><rect width="216" height="162" fill="white"></rect></clipPath></defs>', 2)
  ]));
}
const E1 = /* @__PURE__ */ T(tn, [["render", on]]), sn = ["href"], nn = ["data-test-id"], an = ["href"], ln = ["data-test-id"], rn = { class: "tw-flex tw-w-full tw-justify-between" }, N1 = /* @__PURE__ */ c({
  __name: "cl-sidebar-nav-item-child",
  props: {
    label: {},
    isClosed: { type: Boolean },
    navigate: {},
    href: {},
    isActive: { type: Boolean, default: !1 },
    dataTestId: { default: "child-subnav" },
    disabled: { type: Boolean, default: !1 },
    needsToggle: { type: Boolean, default: !1 },
    hasDescendants: { type: Boolean, default: !1 },
    hasActiveDescendants: { type: Boolean, default: !1 }
  },
  emits: ["on-click"],
  setup(n, { emit: t }) {
    const e = M(!1), s = M(null);
    G(s, () => {
      e.value && (e.value = !1);
    });
    const i = t, r = () => {
      e.value || (e.value = !0), i("on-click", e.value);
    };
    return (d, w) => (a(), l(V, null, [
      d.isClosed ? (a(), l("div", {
        key: 0,
        ref_key: "toggleChild",
        ref: s,
        onClick: w[1] || (w[1] = (u) => r())
      }, [
        o("a", {
          href: d.href,
          class: p({
            "tw-pointer-events-none": d.disabled
          }),
          onClick: w[0] || (w[0] = //@ts-ignore
          (...u) => d.navigate && d.navigate(...u))
        }, [
          o("li", {
            class: p(["tw-flex tw-w-60 tw-cursor-pointer tw-justify-between tw-p-4 hover:tw-bg-aside-400", [
              d.isActive ? "tw-bg-aside-400 tw-px-4 tw-font-bold tw-transition-all" : "tw-bg-aside-600",
              d.disabled && "tw-text-dorian-gray-200 dark:tw-text-dorian-gray-300",
              d.hasDescendants && "tw-pl-8",
              d.hasActiveDescendants && "tw-bg-aside-600 tw-shadow-none"
            ]]),
            "data-test-id": `${d.dataTestId}-closed`
          }, [
            R(C(d.label) + " ", 1),
            d.needsToggle ? (a(), D(h(ot), {
              key: 0,
              class: p(["tw-transition-transform", e.value ? "tw-rotate-180" : "tw-rotate-0"])
            }, null, 8, ["class"])) : x("", !0)
          ], 10, nn)
        ], 10, sn)
      ], 512)) : x("", !0),
      d.isClosed ? x("", !0) : (a(), l("div", {
        key: 1,
        ref_key: "toggleChild",
        ref: s,
        onClick: w[3] || (w[3] = (u) => r())
      }, [
        o("a", {
          href: d.href,
          class: p({
            "tw-pointer-events-none": d.disabled
          }),
          onClick: w[2] || (w[2] = //@ts-ignore
          (...u) => d.navigate && d.navigate(...u))
        }, [
          o("li", {
            class: p(["tw-flex tw-w-full tw-cursor-pointer tw-justify-between tw-p-4 hover:tw-bg-aside-400", [
              d.isActive ? "tw-bg-aside-400 tw-px-4 tw-font-bold tw-shadow-[inset_0.1875rem_0] tw-shadow-white tw-transition-all dark:tw-shadow-dorian-gray-500" : "",
              d.disabled && "tw-text-dorian-gray-200 dark:tw-text-dorian-gray-300",
              d.hasActiveDescendants && "tw-shadow-none"
            ]]),
            "data-test-id": `${d.dataTestId}-open`
          }, [
            o("div", rn, [
              o("span", {
                class: p(d.hasDescendants ? "tw-pl-[75px] " : "tw-pl-10")
              }, C(d.label), 3),
              o("span", null, [
                g(d.$slots, "pill")
              ])
            ]),
            d.needsToggle ? (a(), D(h(ot), {
              key: 0,
              class: p(["tw-transition-transform", e.value ? "tw-rotate-180" : "tw-rotate-0"])
            }, null, 8, ["class"])) : x("", !0)
          ], 10, ln)
        ], 10, an)
      ], 512))
    ], 64));
  }
}), dn = {};
function wn(n, t) {
  return a(), l("nav", null, [
    o("ul", null, [
      g(n.$slots, "default")
    ])
  ]);
}
const O1 = /* @__PURE__ */ T(dn, [["render", wn]]), cn = ["data-test-id"], un = { class: "tw-relative" }, hn = { class: "tw-relative" }, pn = { class: "tw-max-h-[50dvh] tw-w-full tw-overflow-y-auto" }, F1 = /* @__PURE__ */ c({
  __name: "cl-sidebar-dropdown",
  props: {
    testId: { default: "cl-dropdown-toggle-btn" },
    isClosed: { type: Boolean }
  },
  emits: ["on-dropdown"],
  setup(n, { emit: t }) {
    const e = n, s = M(!1), i = M(null);
    G(i, () => {
      s.value && (s.value = !1);
    });
    const r = k(() => [
      s.value ? "tw-opacity-100" : "tw-opacity-0",
      e.isClosed ? "tw-absolute tw-left-[100%] tw-top-0" : ""
    ]), d = t, w = k(() => e.isClosed ? s.value ? "tw-rotate-90" : "tw-rotate-[270deg]" : s.value ? "tw-rotate-180" : "tw-rotate-0"), u = () => {
      s.value = !s.value, s.value && d("on-dropdown");
    };
    return (m, v) => (a(), l("div", {
      ref_key: "target",
      ref: i,
      class: p(["tw-relative", [m.isClosed ? "tw-px-0" : "tw-mx-2"]])
    }, [
      o("button", {
        class: p(["tw-flex tw-min-h-[52px] tw-w-full tw-items-center tw-justify-between tw-bg-aside-400 tw-py-2 tw-text-base tw-font-bold tw-text-white tw-outline-none tw-outline-4 tw-outline-offset-0 tw-transition-all hover:tw-bg-aside-300 dark:tw-text-dorian-gray-500", [
          m.isClosed ? "tw-px-2" : "tw-px-6",
          s.value && !m.isClosed ? "tw-rounded-b-0 tw-rounded-t" : "",
          !s.value && !m.isClosed ? "tw-rounded-b tw-rounded-t" : ""
        ]]),
        type: "button",
        "data-test-id": e.testId,
        onClick: u
      }, [
        v[1] || (v[1] = o("span", { class: "tw-sr-only" }, "Dropdown", -1)),
        g(m.$slots, "title"),
        L(h(ot), {
          class: p(["tw-min-w-[16px] tw-transition-transform", w.value])
        }, null, 8, ["class"])
      ], 10, cn),
      s.value ? (a(), l("div", {
        key: 0,
        class: p(["tw-outline-t-0 tw-absolute tw-right-0 tw-z-10 tw-flex tw-w-full tw-min-w-[240px] tw-flex-col tw-rounded-b-md tw-border tw-border-aside-300/80 tw-bg-aside-400 tw-shadow tw-transition-opacity", r.value]),
        onClick: v[0] || (v[0] = ($) => s.value = !1)
      }, [
        o("div", un, [
          g(m.$slots, "search")
        ]),
        o("div", hn, [
          o("ul", pn, [
            g(m.$slots, "menu")
          ])
        ])
      ], 2)) : x("", !0)
    ], 2));
  }
}), fn = { class: "tw-relative" }, gn = ["for"], bn = ["id", "name", "placeholder", "data-test-id"], vn = { class: "tw-pointer-events-none tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3" }, R1 = /* @__PURE__ */ c({
  __name: "cl-sidebar-dropdown-search",
  props: {
    id: { default: "sidebar-dropdown-search" },
    name: { default: "sidebar-dropdown-search" },
    placeholder: { default: "Search" },
    dataTestId: { default: "sidebar-dropdown-search" }
  },
  emits: ["search"],
  setup(n, { emit: t }) {
    const e = n, s = t, i = (r) => {
      s("search", r.target.value);
    };
    return (r, d) => (a(), l("div", fn, [
      o("label", {
        for: e.id,
        class: "tw-sr-only"
      }, "Search", 8, gn),
      o("input", {
        id: e.id,
        type: "search",
        class: "tw-h-10 tw-w-full tw-border-none tw-bg-white tw-py-2 tw-pl-9 tw-pr-4 tw-text-base tw-text-dorian-gray-500 tw-shadow-none tw-outline-none focus:tw-ring-0 dark:tw-border dark:tw-border-solid dark:tw-border-dorian-gray-100",
        name: e.name,
        placeholder: e.placeholder,
        "data-test-id": e.dataTestId,
        onClick: d[0] || (d[0] = Ct(() => {
        }, ["stop"])),
        onInput: d[1] || (d[1] = (w) => i(w))
      }, null, 40, bn),
      o("div", vn, [
        L(h(zt), {
          width: "20px",
          height: "20px",
          class: "tw-text-dorian-gray-200"
        })
      ])
    ]));
  }
}), U1 = /* @__PURE__ */ c({
  __name: "cl-sidebar-dropdown-menu-item",
  emits: ["on-click"],
  setup(n, { emit: t }) {
    const e = t, s = () => {
      e("on-click");
    };
    return (i, r) => (a(), l("li", {
      class: "tw-cursor-pointer tw-px-6 tw-py-4 hover:tw-bg-aside-300",
      onClick: s
    }, [
      g(i.$slots, "default")
    ]));
  }
}), ht = /* @__PURE__ */ c({
  __name: "cl-heading",
  props: {
    size: { default: "h1" }
  },
  setup(n) {
    const t = n, e = {
      h1: "tw-text-5xl tw-font-medium",
      h2: "tw-text-4xl tw-font-medium",
      h3: "tw-text-3xl tw-font-medium",
      h4: "tw-text-2xl tw-font-semibold",
      h5: "tw-text-xl tw-font-semibold",
      h6: "tw-text-lg tw-font-semibold"
    }, s = k(() => [
      "tw-text-dorian-gray-500",
      "tw-mb-3",
      e[t.size]
    ]);
    return (i, r) => (a(), D(rt(t.size), {
      class: p(s.value)
    }, {
      default: N(() => [
        g(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), mn = ["id"], Vt = /* @__PURE__ */ c({
  __name: "cl-tooltip",
  props: {
    id: {},
    text: {},
    position: { default: "top" }
  },
  setup(n) {
    const t = {
      top: "tw--top-3 tw-left-1/2 tw--translate-x-1/2 tw--translate-y-1/2 tw-transform",
      bottom: "tw--bottom-8 tw-left-1/2 tw--translate-x-1/2 tw--translate-y-1/2 tw-transform"
    }, e = n, s = k(() => [t[e.position]]), i = M(!1);
    return (r, d) => (a(), l("div", {
      class: "tw-relative tw-inline-block",
      onMouseover: d[0] || (d[0] = (w) => i.value = !0),
      onMouseleave: d[1] || (d[1] = (w) => i.value = !1)
    }, [
      g(r.$slots, "default"),
      i.value ? (a(), l("span", {
        key: 0,
        id: e.id,
        class: p(["tw-absolute tw-z-10 tw-h-fit tw-min-w-max tw-rounded tw-border tw-border-solid tw-border-dorian-gray-200 tw-bg-white tw-px-2 tw-shadow", s.value]),
        role: "tooltip"
      }, C(r.text), 11, mn)) : x("", !0)
    ], 32));
  }
}), _n = { class: "tw-p-2" }, yn = { class: "tw-w-full" }, xn = { class: "tw-grid tw-grid-cols-12 tw-gap-1" }, Cn = { class: "tw-col-span-12 md:tw-col-span-6" }, kn = {
  key: 0,
  class: "tw-w-full"
}, $n = { class: "tw-relative md:tw-max-w-xs" }, Mn = ["data-test-id", "placeholder"], Bn = { class: "tw-pointer-events-none tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3" }, Ln = { class: "tw-col-span-12 md:tw-col-span-6" }, Hn = { class: "tw-flex tw-w-full tw-items-center tw-justify-end" }, In = {
  key: 0,
  class: "tw-flex tw-items-center"
}, zn = {
  key: 0,
  class: "tw-relative"
}, Vn = { class: "tw-whitespace-nowrap tw-pr-2 tw-text-sm tw-text-dorian-gray-500" }, Tn = {
  key: 1,
  class: "tw-relative"
}, Sn = ["data-test-id"], jn = {
  key: 2,
  class: "tw-relative"
}, Zn = ["data-test-id"], Dn = {
  key: 3,
  class: "tw-relative"
}, An = ["data-test-id"], Pn = {
  key: 0,
  id: "set-rows-wrapper",
  class: "tw-absolute tw-right-0 tw-z-10 tw-m-1 tw-flex tw-min-w-max tw-flex-col tw-rounded-md tw-border tw-border-dorian-gray-100 tw-bg-white tw-p-2 tw-shadow-md tw-transition-opacity"
}, En = ["for"], Nn = ["id", "value", "disabled"], On = { class: "tw-mb-6tw-p-2" }, Fn = { class: "tw-w-full tw-rounded tw-text-left tw-text-base tw-shadow dark:tw-border dark:tw-border-solid dark:tw-border-dorian-gray-100/80 dark:tw-shadow-none" }, Rn = { class: "tw-bg-white" }, Un = {
  key: 0,
  scope: "col",
  class: "tw-pl-4"
}, Wn = { class: "tw-flex tw-items-center" }, Gn = ["disabled"], Qn = ["onClick"], Kn = { class: "tw-whitespace-nowrap tw-font-bold" }, qn = { key: 0 }, Jn = { key: 0 }, Xn = {
  key: 0,
  class: "tw-w-4 tw-px-4"
}, Yn = { key: 1 }, ta = {
  key: 0,
  class: "tw-border-b tw-border-dorian-gray-100/80 tw-bg-light"
}, ea = ["onClick"], oa = { class: "tw-flex tw-items-center" }, sa = ["id", "data-test-id", "value", "disabled"], na = ["for"], aa = { class: "tw-mb-6 tw-p-2" }, la = { class: "tw-w-full" }, ra = { class: "tw-grid tw-grid-cols-12 tw-gap-1" }, ia = { class: "tw-col-span-12 md:tw-col-span-6" }, da = { class: "tw-relative" }, wa = { class: "tw-mr-4 tw-inline-flex tw-h-10 tw-items-baseline tw-justify-start" }, ca = ["value", "selected"], ua = {
  key: 0,
  class: "tw-inline-flex tw-h-10 tw-items-baseline tw-justify-start"
}, ha = { class: "tw-text-sm tw-text-dorian-gray-500" }, pa = { class: "tw-col-span-12 md:tw-col-span-6" }, fa = { class: "tw-relative tw-flex tw-justify-end" }, ga = ["disabled"], ba = ["disabled"], Y = 1, W1 = /* @__PURE__ */ c({
  __name: "cl-data-table",
  props: {
    headers: {},
    items: {},
    total: {},
    itemsPerPage: { default: () => [10, 25, 50] },
    testId: { default: "default-test-id" },
    fetching: { type: Boolean, default: !1 },
    withSelect: { type: Boolean, default: !1 },
    withSelectAll: { type: Boolean, default: !0 },
    withSearch: { type: Boolean, default: !1 },
    withDelete: { type: Boolean, default: !1 },
    withRelease: { type: Boolean, default: !1 },
    withAllow: { type: Boolean, default: !1 },
    withServerSidePagination: { type: Boolean, default: !1 },
    deletePlaceholder: { default: "Delete" },
    releasePlaceholder: { default: "Release" },
    allowPlaceholder: { default: "Allow" },
    searchPlaceholder: { default: "Search" },
    searchBy: { default: "id" },
    withSetColumns: { type: Boolean, default: !1 },
    zebra: { type: Boolean, default: !0 },
    defaultItemsOnPage: { default: 10 },
    defaultSortBy: { default: "" },
    defaultSortDesc: { default: "desc" },
    withRowClick: { type: Boolean, default: !1 },
    px: { default: 6 }
  },
  emits: ["onDeleteItems", "onReleaseItems", "onAllowItems", "search", "sortItems", "changePage", "changeItemsOnPage", "changeSelectedColumns", "onSelectItems", "onRowClick"],
  setup(n, { emit: t }) {
    const e = n, s = t, i = st(), r = M(!1), d = M(""), w = M(e.defaultItemsOnPage || e.itemsPerPage[0]), u = M(e.defaultSortBy), m = M(e.defaultSortDesc), v = M(!1), $ = M([]), y = M(Y), B = M(null), I = M(null), nt = () => {
      B.value && (B.value.scrollTop = B.value.scrollHeight);
    }, P = M(
      e.headers.map((b) => {
        const _ = { ...b };
        return "enabled" in _ || (_.enabled = !0), _;
      })
    ), W = M(
      P.value.filter((b) => b.enabled).map((b) => b.key)
    ), O = M(
      P.value.filter((b) => b.enabled).map((b) => b.key)
    ), at = k(() => {
      const b = y.value * w.value;
      return { start: b - w.value, end: b };
    }), dt = k(() => {
      if (e.withServerSidePagination)
        return e.items;
      const b = [...e.items];
      return u.value && b.sort((_, f) => {
        const H = _[u.value], E = f[u.value];
        if (typeof H == "number" && typeof E == "number")
          return m.value === "asc" ? H - E : E - H;
        if (typeof H == "string" && typeof E == "string") {
          const K = Date.parse(H), X = Date.parse(E);
          return isNaN(K) ? m.value === "asc" ? H.localeCompare(E) : E.localeCompare(H) : m.value === "asc" ? K - X : X - K;
        }
        return m.value === "asc" ? H - E : E - H;
      }), e.withSearch && d.value ? b.filter(
        (_) => _[e.searchBy].toLowerCase().includes(d.value.toLowerCase())
      ) : b;
    }), J = k(() => e.withServerSidePagination ? e.items : dt.value.slice(
      at.value.start,
      at.value.end
    )), Tt = k(() => d.value.length !== 0 && !e.withServerSidePagination ? Math.ceil(dt.value.length / w.value) : Math.ceil(e.total / w.value)), pt = k(() => $.value.length > 0), St = (b) => b != null && b.sticky ? "tw-sticky tw-right-0 tw-bg-white" : "", jt = (b) => {
      let _ = b != null && b.sticky ? "tw-border-l tw-border-dorian-gray-100/80" : "";
      return _ += ` tw-px-${e.px}`, _;
    }, Zt = (b) => {
      const _ = e.headers.find((H) => H.key === b);
      return _ != null && _.sticky ? "tw-sticky tw-right-0 tw-bg-[inherit]" : "";
    }, Dt = (b) => {
      const _ = e.headers.find((H) => H.key === b);
      let f = _ != null && _.sticky ? "tw-border-l tw-border-dorian-gray-100/80" : "";
      return f += ` tw-px-${e.px}`, f;
    }, At = (b) => {
      const _ = b.target.checked;
      $.value = _ ? [...J.value.filter((f) => {
        var H;
        return !((H = f.metadata) != null && H.inherited);
      })] : [];
    }, Pt = () => {
      e.withSelectAll || ($.value = $.value.slice(-1)), v.value && (v.value = !1);
    }, Et = () => {
      Q(), y.value = y.value + 1, s("changePage", y.value);
    }, Nt = () => {
      Q(), y.value = y.value - 1, s("changePage", y.value);
    }, Ot = () => {
      y.value = Y, s("changeItemsOnPage", w.value);
    }, Q = () => {
      v.value = !1, $.value = [];
    }, Ft = k(() => {
      const b = [];
      for (let _ = 0; _ < 10; _++) {
        const f = {};
        e.headers.forEach((H) => {
          f[H.key] = "";
        }), b.push(f);
      }
      return b;
    }), Rt = (b) => {
      b.sortable && (u.value !== b.key && (u.value = b.key), m.value === "asc" ? m.value = "desc" : m.value = "asc", s("sortItems", u.value, m.value));
    }, Ut = () => {
      s("onDeleteItems", $.value), Q();
    }, Wt = () => {
      s("onReleaseItems", $.value), Q();
    }, Gt = () => {
      s("onAllowItems", $.value), Q();
    }, Qt = (b) => {
      y.value = Y, s("search", b.target.value);
    }, Kt = () => {
      r.value = !r.value;
    };
    G(I, () => {
      r.value = !1;
    });
    const lt = M(null), qt = (b) => {
      lt.value = b.id, s("onRowClick", b);
    };
    return S(
      () => e.headers,
      () => {
        P.value = e.headers.map((b) => {
          const _ = { ...b };
          return "enabled" in _ || (_.enabled = !0), _;
        }), O.value = P.value.filter((b) => b.enabled).map((b) => b.key);
      },
      { deep: !0 }
    ), S(
      () => O.value,
      () => {
        P.value = P.value.map((b) => ({
          ...b,
          enabled: O.value.includes(b.key)
        })), W.value = P.value.filter((b) => b.enabled).map((b) => b.key), s("changeSelectedColumns", O.value);
      }
    ), S(
      () => e.defaultItemsOnPage,
      () => {
        w.value = e.defaultItemsOnPage || e.itemsPerPage[0];
      }
    ), S(
      () => e.defaultSortBy,
      () => {
        u.value = e.defaultSortBy;
      }
    ), S(
      () => e.defaultSortDesc,
      () => {
        m.value = e.defaultSortDesc;
      }
    ), S(
      () => e.items,
      () => {
        Q();
      }
    ), S(
      () => $.value,
      () => {
        s("onSelectItems", $.value);
      }
    ), S(
      () => e.total,
      () => y.value = Y
    ), (b, _) => (a(), l(V, null, [
      o("section", _n, [
        o("div", yn, [
          o("div", xn, [
            o("div", Cn, [
              e.withSearch ? (a(), l("div", kn, [
                _[7] || (_[7] = o("label", {
                  for: "cl-data-table-search",
                  class: "tw-sr-only"
                }, "Search", -1)),
                o("div", $n, [
                  A(o("input", {
                    id: "cl-data-table-search",
                    "onUpdate:modelValue": _[0] || (_[0] = (f) => d.value = f),
                    class: p(["tw-block tw-w-full tw-rounded tw-border tw-border-solid tw-border-dorian-gray-100/80 tw-bg-white tw-py-2 tw-pl-9 tw-pr-2 tw-text-base tw-text-dorian-gray-500 tw-outline-none tw-transition-all focus:tw-border-secondary-500 focus:tw-ring-4 focus:tw-ring-secondary-500/10", [pt.value ? "tw-w-1/2" : "tw-w-full"]]),
                    type: "search",
                    "data-test-id": `${e.testId}-search`,
                    placeholder: e.searchPlaceholder,
                    onInput: _[1] || (_[1] = (f) => Qt(f))
                  }, null, 42, Mn), [
                    [ct, d.value]
                  ]),
                  o("div", Bn, [
                    L(h(zt), {
                      width: "20px",
                      height: "20px",
                      class: "tw-text-dorian-gray-200"
                    })
                  ])
                ])
              ])) : x("", !0),
              g(b.$slots, "search")
            ]),
            o("div", Ln, [
              o("div", Hn, [
                pt.value ? (a(), l("div", In, [
                  $.value ? (a(), l("div", zn, [
                    o("span", Vn, C($.value.length) + " Selected", 1)
                  ])) : x("", !0),
                  e.withDelete ? (a(), l("div", Tn, [
                    o("button", {
                      class: "tw-m-1 tw-inline-flex tw-h-10 tw-items-center tw-rounded tw-border tw-border-solid tw-border-danger-500 tw-bg-none tw-px-6 tw-text-base tw-font-medium tw-text-danger-500 tw-outline-none tw-outline-offset-0 tw-transition-all hover:tw-text-danger-600 focus:tw-outline-4 focus:tw-outline-danger-500/10 active:tw-border-danger-800 active:tw-text-danger-800",
                      type: "button",
                      "data-test-id": `${e.testId}-delete`,
                      onClick: Ut
                    }, C(e.deletePlaceholder), 9, Sn)
                  ])) : x("", !0),
                  e.withRelease ? (a(), l("div", jn, [
                    o("button", {
                      class: "tw-m-1 tw-inline-flex tw-h-10 tw-items-center tw-rounded tw-border tw-border-solid tw-border-secondary-500 tw-bg-none tw-px-6 tw-text-base tw-font-medium tw-text-secondary-500 tw-outline-none tw-outline-offset-0 tw-transition-all hover:tw-text-secondary-600 focus:tw-outline-4 focus:tw-outline-secondary-500/10 active:tw-border-secondary-800 active:tw-text-secondary-800",
                      type: "button",
                      "data-test-id": `${e.testId}-release`,
                      onClick: Wt
                    }, C(e.releasePlaceholder), 9, Zn)
                  ])) : x("", !0),
                  e.withAllow ? (a(), l("div", Dn, [
                    o("button", {
                      class: "tw-m-1 tw-inline-flex tw-h-10 tw-items-center tw-rounded tw-border tw-border-solid tw-border-secondary-500 tw-bg-none tw-px-6 tw-text-base tw-font-medium tw-text-secondary-500 tw-outline-none tw-outline-offset-0 tw-transition-all hover:tw-text-secondary-600 focus:tw-outline-4 focus:tw-outline-secondary-500/10 active:tw-border-secondary-800 active:tw-text-secondary-800",
                      type: "button",
                      "data-test-id": `${e.testId}-allow`,
                      onClick: Gt
                    }, C(e.allowPlaceholder), 9, An)
                  ])) : x("", !0)
                ])) : x("", !0),
                h(i).actions ? g(b.$slots, "actions", {
                  key: 1,
                  selectedItems: $.value
                }) : x("", !0),
                b.withSetColumns ? (a(), l("div", {
                  key: 2,
                  ref_key: "columnSetTooltip",
                  ref: I,
                  class: "column-set-tooltip-wrapper"
                }, [
                  o("button", {
                    class: "tw-group tw-mx-4 tw-flex tw-h-9 tw-items-center tw-justify-center tw-border-l-2 tw-border-solid tw-border-dorian-gray-100 tw-pl-4",
                    onClick: Kt
                  }, [
                    L(h(Yo), {
                      width: "24",
                      height: "24",
                      class: p([
                        "tw-transition-colors group-hover:tw-stroke-secondary-500",
                        r.value ? "tw-stroke-secondary-500" : "tw-stroke-dorian-gray-500"
                      ])
                    }, null, 8, ["class"])
                  ]),
                  r.value ? (a(), l("div", Pn, [
                    (a(!0), l(V, null, Z(P.value, (f) => (a(), l("div", {
                      key: f.key,
                      class: "tw-my-1"
                    }, [
                      o("label", {
                        for: f.key,
                        class: "tw-ml-2 tw-flex tw-items-center"
                      }, [
                        A(o("input", {
                          id: f.key,
                          "onUpdate:modelValue": _[2] || (_[2] = (H) => O.value = H),
                          value: f.key,
                          type: "checkbox",
                          class: "tw-h-4 tw-w-4 tw-cursor-pointer tw-rounded tw-border-2 tw-border-solid tw-border-dorian-gray-500 tw-bg-white tw-text-secondary-500 checked:tw-border-secondary-500 focus:tw-ring-secondary-500 focus:tw-ring-offset-white disabled:tw-border-dorian-gray-100 disabled:tw-text-dorian-gray-100 disabled:checked:tw-border-dorian-gray-100 dark:tw-border-dorian-gray-400",
                          disabled: O.value.length <= 1 && f.enabled
                        }, null, 8, Nn), [
                          [q, O.value]
                        ]),
                        o("span", {
                          class: p([
                            "text-dorian-gray-300 tw-ml-3 tw-text-base",
                            O.value.length <= 1 && f.enabled && "tw-text-dorian-gray-200"
                          ])
                        }, C(f.label), 3)
                      ], 8, En)
                    ]))), 128))
                  ])) : x("", !0)
                ], 512)) : x("", !0)
              ])
            ])
          ])
        ])
      ]),
      o("section", On, [
        o("div", {
          ref_key: "scrollContainer",
          ref: B,
          class: "tw-overflow-x-auto tw-shadow"
        }, [
          o("table", Fn, [
            o("thead", Rn, [
              o("tr", null, [
                e.withSelect ? (a(), l("th", Un, [
                  o("div", Wn, [
                    A(o("input", {
                      id: "table-header-select-all",
                      "onUpdate:modelValue": _[3] || (_[3] = (f) => v.value = f),
                      disabled: !e.withSelectAll,
                      type: "checkbox",
                      class: p({
                        "tw-h-4 tw-w-4 tw-rounded tw-border-2 tw-border-solid tw-border-dorian-gray-100 tw-bg-dorian-gray-100 hover:tw-cursor-not-allowed dark:tw-border-dorian-gray-50": !e.withSelectAll,
                        "tw-h-4 tw-w-4 tw-cursor-pointer tw-rounded tw-border-2 tw-border-solid tw-border-dorian-gray-500 tw-bg-white tw-text-secondary-500 checked:tw-border-secondary-500 focus:tw-ring-secondary-500 focus:tw-ring-offset-white disabled:tw-border-dorian-gray-100 disabled:tw-text-dorian-gray-100 disabled:checked:tw-border-dorian-gray-100 dark:tw-border-dorian-gray-400": e.withSelectAll
                      }),
                      onChange: At
                    }, null, 42, Gn), [
                      [q, v.value]
                    ]),
                    _[8] || (_[8] = o("label", {
                      for: "table-header-select-all",
                      class: "tw-sr-only"
                    }, "checkbox", -1))
                  ])
                ])) : x("", !0),
                (a(!0), l(V, null, Z(P.value, (f) => (a(), l(V, {
                  key: f.label
                }, [
                  f.enabled ? (a(), l("th", {
                    key: 0,
                    scope: "col",
                    class: p(St(f))
                  }, [
                    o("div", {
                      class: p(["tw-inline-flex tw-items-center tw-py-1", jt(f)])
                    }, [
                      o("div", {
                        class: p([
                          "tw-peer",
                          f.sortable ? "hover:tw-cursor-pointer" : "tw-cursor-auto"
                        ]),
                        onClick: (H) => Rt(f)
                      }, [
                        g(b.$slots, `header.cell.${String(
                          f.label
                        ).toLocaleLowerCase()}`, {
                          text: f.label
                        }, () => [
                          o("span", Kn, C(f.label), 1)
                        ])
                      ], 10, Qn),
                      f.tooltip ? (a(), D(h(Vt), {
                        key: 0,
                        id: f.key,
                        text: f.tooltip,
                        class: "tw-ml-1 hover:tw-cursor-pointer"
                      }, {
                        default: N(() => [
                          f.tooltip ? (a(), l("span", qn, [
                            L(h(Ht), {
                              width: 16,
                              height: 16
                            })
                          ])) : x("", !0)
                        ]),
                        _: 2
                      }, 1032, ["id", "text"])) : x("", !0),
                      o("span", {
                        class: p(
                          f.sortable && u.value === f.key ? "peer-hover:tw-visible" : "tw-invisible"
                        )
                      }, [
                        m.value === "desc" ? (a(), D(h(as), {
                          key: 0,
                          width: "16",
                          height: "16"
                        })) : (a(), D(h(rs), {
                          key: 1,
                          width: "16",
                          height: "16"
                        }))
                      ], 2)
                    ], 2)
                  ], 2)) : x("", !0)
                ], 64))), 128))
              ])
            ]),
            e.fetching ? (a(), l("tbody", Jn, [
              (a(!0), l(V, null, Z(Ft.value, (f) => (a(), l("tr", {
                key: f.id,
                class: "tw-border-b tw-border-dorian-gray-100/80 tw-bg-white"
              }, [
                e.withSelect ? (a(), l("td", Xn, _[9] || (_[9] = [
                  o("div", { class: "tw-w-30 tw-h-5 tw-animate-pulse tw-bg-light" }, null, -1)
                ]))) : x("", !0),
                (a(!0), l(V, null, Z(W.value, (H) => (a(), l("td", {
                  key: f[H],
                  class: "h-2 bg-slate-200 rounded tw-animate-pulse tw-whitespace-nowrap tw-px-6"
                }, _[10] || (_[10] = [
                  o("div", { class: "tw-w-30 tw-h-5 tw-animate-pulse tw-bg-light" }, null, -1)
                ])))), 128))
              ]))), 128))
            ])) : (a(), l("tbody", Yn, [
              J.value.length === 0 ? (a(), l("tr", ta, _[11] || (_[11] = [
                o("td", {
                  colspan: "100%",
                  class: "tw-pl-2 tw-text-center"
                }, " No data available ", -1)
              ]))) : x("", !0),
              (a(!0), l(V, null, Z(J.value, (f, H) => {
                var E, K, X;
                return a(), l("tr", {
                  key: f.id,
                  class: p(["tw-border-b tw-border-dorian-gray-100/80", [
                    lt.value === f.id && e.withRowClick ? "tw-bg-secondary-200" : "hover:tw-bg-secondary-50 dark:hover:tw-bg-dorian-gray-100",
                    e.zebra && H % 2 === 0 && lt.value !== f.id ? "tw-bg-light" : "",
                    e.zebra && H % 2 !== 0 && lt.value !== f.id ? "tw-bg-white" : ""
                  ]]),
                  onClick: (F) => qt(f)
                }, [
                  e.withSelect ? (a(), l("td", {
                    key: 0,
                    class: "tw-w-4 tw-px-4",
                    onClick: _[5] || (_[5] = Ct(() => {
                    }, ["stop"]))
                  }, [
                    o("div", oa, [
                      A(o("input", {
                        id: `select-${f.id}`,
                        "onUpdate:modelValue": _[4] || (_[4] = (F) => $.value = F),
                        "data-test-id": `${e.testId}-checkbox-selected-${f.id}`,
                        value: f,
                        type: "checkbox",
                        class: p({
                          "tw-h-4 tw-w-4 tw-rounded tw-border-2 tw-border-solid tw-border-dorian-gray-100 tw-bg-dorian-gray-100 hover:tw-cursor-not-allowed dark:tw-border-dorian-gray-50": (E = f.metadata) == null ? void 0 : E.inherited,
                          "tw-h-4 tw-w-4 tw-cursor-pointer tw-rounded tw-border-2 tw-border-solid tw-border-dorian-gray-500 tw-bg-white tw-text-secondary-500 checked:tw-border-secondary-500 focus:tw-ring-secondary-500 focus:tw-ring-offset-white disabled:tw-border-dorian-gray-100 disabled:tw-text-dorian-gray-100 disabled:checked:tw-border-dorian-gray-100 dark:tw-border-dorian-gray-400": !((K = f.metadata) != null && K.inherited)
                        }),
                        disabled: (X = f.metadata) == null ? void 0 : X.inherited,
                        onChange: Pt
                      }, null, 42, sa), [
                        [q, $.value]
                      ]),
                      o("label", {
                        for: `select-${f.id}`,
                        class: "tw-sr-only"
                      }, "checkbox", 8, na)
                    ])
                  ])) : x("", !0),
                  (a(!0), l(V, null, Z(W.value, (F) => (a(), l("td", {
                    key: f[F],
                    class: p(["tw-relative tw-align-middle", Zt(F)])
                  }, [
                    o("div", {
                      class: p(["tw-flex tw-whitespace-nowrap tw-py-1", Dt(F)]),
                      onClick: nt
                    }, [
                      g(b.$slots, `body.cell.${String(F).toLocaleLowerCase()}`, {
                        tdValue: f[F],
                        trItem: f
                      }, () => [
                        R(C(f[F]), 1)
                      ])
                    ], 2)
                  ], 2))), 128))
                ], 10, ea);
              }), 128))
            ]))
          ])
        ], 512)
      ]),
      o("section", aa, [
        o("div", la, [
          g(b.$slots, "pagination", {}, () => [
            o("div", ra, [
              o("div", ia, [
                o("div", da, [
                  o("div", wa, [
                    _[12] || (_[12] = o("label", { class: "tw-mr-4 tw-whitespace-nowrap tw-text-sm tw-text-dorian-gray-500" }, " Rows per page: ", -1)),
                    A(o("select", {
                      "onUpdate:modelValue": _[6] || (_[6] = (f) => w.value = f),
                      name: "rows-per-page",
                      class: "tw-focus:border-gray-200 peer tw-block tw-w-full tw-appearance-none tw-border-0 tw-border-b-2 tw-border-solid tw-border-dorian-gray-100/80 tw-bg-white tw-text-sm tw-text-dorian-gray-500 tw-outline-none focus:tw-border-secondary-500 focus:tw-ring-0",
                      onChange: Ot
                    }, [
                      (a(!0), l(V, null, Z(e.itemsPerPage, (f) => (a(), l("option", {
                        key: f,
                        value: f,
                        selected: f === w.value
                      }, C(f), 9, ca))), 128))
                    ], 544), [
                      [kt, w.value]
                    ])
                  ]),
                  J.value.length !== 0 ? (a(), l("div", ua, [
                    o("span", ha, [
                      R(C(at.value.start + 1) + "-" + C(at.value.start + J.value.length) + " ", 1),
                      o("span", null, "of " + C(e.withServerSidePagination ? e.total : dt.value.length), 1)
                    ])
                  ])) : x("", !0)
                ])
              ]),
              o("div", pa, [
                o("div", fa, [
                  o("button", {
                    class: "tw-bg-transparent tw-mr-[-1px] tw-rounded-l tw-border-2 tw-border-solid tw-border-secondary-500 tw-px-2 tw-text-sm tw-font-medium tw-text-dorian-gray-200 hover:tw-text-secondary-500 disabled:tw-cursor-default disabled:tw-border-r disabled:tw-border-dorian-gray-100/80 disabled:tw-text-dorian-gray-200",
                    disabled: y.value === Y,
                    onClick: Nt
                  }, [
                    _[13] || (_[13] = o("span", { class: "tw-sr-only" }, "Previous", -1)),
                    L(h(ds), {
                      width: "16",
                      height: "16"
                    })
                  ], 8, ga),
                  o("button", {
                    class: "tw-bg-transparent tw-ml-[-1px] tw-rounded-r tw-border-2 tw-border-solid tw-border-secondary-500 tw-px-2 tw-text-sm tw-font-medium tw-text-dorian-gray-200 hover:tw-text-secondary-500 disabled:tw-cursor-default disabled:tw-border-l disabled:tw-border-dorian-gray-100/80 disabled:tw-text-dorian-gray-200",
                    disabled: y.value >= Tt.value,
                    onClick: Et
                  }, [
                    _[14] || (_[14] = o("span", { class: "tw-sr-only" }, "Next", -1)),
                    L(h(Lt), {
                      width: "16",
                      height: "16"
                    })
                  ], 8, ba)
                ])
              ])
            ])
          ])
        ])
      ])
    ], 64));
  }
}), G1 = /* @__PURE__ */ c({
  __name: "cl-data-table-edit-action",
  emits: ["on-click"],
  setup(n, { emit: t }) {
    const e = t, s = () => {
      e("on-click");
    };
    return (i, r) => (a(), l("button", {
      type: "button",
      class: "tw-mx-2 tw-rounded-full tw-border-none tw-bg-secondary-100/0 tw-text-dorian-gray-500 tw-outline-none tw-ring-4 tw-ring-secondary-100/0 tw-transition-all hover:tw-cursor-pointer hover:tw-bg-secondary-100 hover:tw-text-secondary-500 hover:tw-ring-secondary-100 active:tw-bg-secondary-200 active:tw-ring-secondary-200 dark:hover:tw-bg-secondary-200 dark:hover:tw-ring-secondary-200 dark:active:tw-bg-secondary-100 dark:active:tw-ring-secondary-100",
      onClick: s
    }, [
      L(h(Io), {
        width: "18",
        height: "18"
      })
    ]));
  }
}), Q1 = /* @__PURE__ */ c({
  __name: "cl-data-table-view-action",
  emits: ["on-click"],
  setup(n, { emit: t }) {
    const e = t, s = () => {
      e("on-click");
    };
    return (i, r) => (a(), l("button", {
      type: "button",
      class: "tw-mx-2 tw-rounded-full tw-border-none tw-bg-secondary-100/0 tw-text-dorian-gray-500 tw-outline-none tw-ring-4 tw-ring-secondary-100/0 tw-transition-all hover:tw-cursor-pointer hover:tw-bg-secondary-100 hover:tw-text-secondary-500 hover:tw-ring-secondary-100 active:tw-bg-secondary-200 active:tw-ring-secondary-200 dark:hover:tw-bg-secondary-200 dark:hover:tw-ring-secondary-200 dark:active:tw-bg-secondary-100 dark:active:tw-ring-secondary-100",
      onClick: s
    }, [
      L(h(To), {
        width: "18",
        height: "18"
      })
    ]));
  }
}), K1 = /* @__PURE__ */ c({
  __name: "cl-data-table-delete-action",
  emits: ["on-click"],
  setup(n, { emit: t }) {
    const e = t, s = () => {
      e("on-click");
    };
    return (i, r) => (a(), l("button", {
      type: "button",
      class: "tw-mx-2 tw-rounded-full tw-border-none tw-bg-secondary-100/0 tw-text-dorian-gray-500 tw-outline-none tw-ring-4 tw-ring-secondary-100/0 tw-transition-all hover:tw-cursor-pointer hover:tw-bg-secondary-100 hover:tw-text-secondary-500 hover:tw-ring-secondary-100 active:tw-bg-secondary-200 active:tw-ring-secondary-200 dark:hover:tw-bg-secondary-200 dark:hover:tw-ring-secondary-200 dark:active:tw-bg-secondary-100 dark:active:tw-ring-secondary-100",
      onClick: s
    }, [
      L(h(es), {
        width: "18",
        height: "18"
      })
    ]));
  }
}), va = { class: "tw-mb-0 tw-w-full tw-py-1 tw-text-base tw-font-normal tw-text-dorian-gray-500" }, q1 = /* @__PURE__ */ c({
  __name: "cl-data-table-more-action",
  setup(n) {
    const t = M(!1), e = M(null);
    G(e, () => {
      t.value && (t.value = !1);
    });
    const s = k(() => ["tw-top-6", t.value ? "tw-opacity-100" : "tw-opacity-0"]);
    return (i, r) => (a(), l("div", {
      ref_key: "target",
      ref: e,
      class: "wrap tw-relative tw-top-[3px] tw-inline-block tw-w-6"
    }, [
      o("button", {
        class: "tw-mx-2 tw-rounded-full tw-border-none tw-bg-secondary-100/0 tw-text-dorian-gray-500 tw-outline-none tw-ring-4 tw-ring-secondary-100/0 tw-transition-all hover:tw-cursor-pointer hover:tw-bg-secondary-100 hover:tw-text-secondary-500 hover:tw-ring-secondary-100 focus:tw-bg-secondary-200 focus:tw-text-secondary-500 focus:tw-ring-secondary-200 active:tw-bg-secondary-200 active:tw-ring-secondary-200 dark:hover:tw-bg-secondary-200 dark:hover:tw-ring-secondary-200 dark:active:tw-bg-secondary-100 dark:active:tw-ring-secondary-100",
        type: "button",
        onClick: r[0] || (r[0] = (d) => t.value = !t.value)
      }, [
        L(h(ss), {
          width: "18",
          height: "18"
        })
      ]),
      t.value ? (a(), l("div", {
        key: 0,
        class: p(["tw-absolute tw-right-0 tw-z-10 tw-m-1 tw-flex tw-min-w-max tw-rounded-md tw-border tw-border-dorian-gray-100 tw-bg-white tw-shadow-md tw-transition-opacity", s.value]),
        onClick: r[1] || (r[1] = (d) => t.value = !1)
      }, [
        o("ul", va, [
          g(i.$slots, "default")
        ])
      ], 2)) : x("", !0)
    ], 512));
  }
}), J1 = /* @__PURE__ */ c({
  __name: "cl-data-table-more-action-item",
  props: {
    bordered: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["on-click"],
  setup(n, { emit: t }) {
    const e = n, s = k(() => [
      "tw-block tw-cursor-pointer tw-border-b tw-px-4 tw-py-2 tw-text-left",
      e.bordered ? "tw-border-dorian-gray-50" : "tw-border-none",
      e.disabled ? "tw-pointer-events-none tw-text-dorian-gray-200" : "hover:tw-bg-light"
    ]), i = t, r = () => {
      i("on-click");
    };
    return (d, w) => (a(), l("li", {
      class: p(s.value),
      onClick: r
    }, [
      g(d.$slots, "default")
    ], 2));
  }
}), X1 = /* @__PURE__ */ c({
  __name: "cl-pill",
  props: {
    variant: { default: "info" },
    size: { default: "xs" },
    uppercase: { type: Boolean, default: !0 }
  },
  setup(n) {
    const t = {
      info: "tw-border-info-500 tw-text-info-500",
      warning: "tw-border-warning-500 tw-text-warning-500",
      danger: "tw-border-danger-500 tw-text-danger-500",
      success: "tw-border-success-500 tw-text-success-500",
      infoFull: "tw-border-info-600 tw-bg-info-600 tw-text-white",
      successFull: "tw-border-success-500 tw-bg-success-500 tw-text-white"
    }, e = {
      xs: "tw-text-xs tw-px-2",
      sm: "tw-text-sm tw-px-2 tw-py-1"
    }, s = n, i = k(() => [
      "tw-rounded-2xl tw-border tw-border-solid tw-font-semibold tw-inline-block",
      t[s.variant],
      e[s.size],
      s.uppercase && "tw-uppercase"
    ]);
    return (r, d) => (a(), l("span", {
      class: p(i.value)
    }, [
      g(r.$slots, "default")
    ], 2));
  }
}), ma = ["data-test-id"], _a = { class: "tw-grid tw-grid-flow-row" }, ya = {
  key: 0,
  class: "tw-p-4"
}, xa = {
  key: 1,
  class: "tw-p-4"
}, Ca = {
  key: 2,
  class: "tw-bg-light tw-p-4"
}, Y1 = /* @__PURE__ */ c({
  __name: "cl-card",
  props: {
    dataTestId: { default: "" },
    title: { default: "" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("div", {
      class: "tw-block tw-rounded-sm tw-bg-white tw-shadow",
      "data-test-id": t.dataTestId
    }, [
      o("div", _a, [
        e.$slots.title || t.title !== "" ? (a(), l("div", ya, [
          e.$slots.title ? g(e.$slots, "title", { key: 0 }) : (a(), D(h(ht), {
            key: 1,
            size: "h6",
            class: "tw-mb-0"
          }, {
            default: N(() => [
              R(C(t.title), 1)
            ]),
            _: 1
          }))
        ])) : x("", !0),
        e.$slots.text ? (a(), l("div", xa, [
          g(e.$slots, "text")
        ])) : x("", !0),
        e.$slots.footer ? (a(), l("div", Ca, [
          g(e.$slots, "footer")
        ])) : x("", !0)
      ])
    ], 8, ma));
  }
}), xt = /* @__PURE__ */ c({
  __name: "cl-skeleton",
  props: {
    size: { default: "sm" }
  },
  setup(n) {
    const t = {
      sm: "tw-max-w-sm"
    }, e = n, s = k(() => [t[e.size], "tw-animate-pulse"]);
    return (i, r) => (a(), l("div", {
      role: "status",
      class: p(s.value),
      "data-test-id": "skeleton"
    }, [
      g(i.$slots, "default"),
      r[0] || (r[0] = o("span", { class: "tw-sr-only" }, "Loading...", -1))
    ], 2));
  }
}), ti = /* @__PURE__ */ c({
  __name: "cl-skeleton-row",
  props: {
    width: { default: "xs" },
    bg: { default: "default" }
  },
  setup(n) {
    const t = {
      xs: "tw-max-w-[270px]",
      sm: "tw-max-w-[300px]",
      md: "tw-max-w-[330px]",
      lg: "tw-max-w-[360px]"
    }, e = {
      light: "tw-bg-dorian-gray-50",
      default: "tw-bg-dorian-gray-100"
    }, s = n, i = k(() => [
      t[s.width],
      "tw-mb-4 tw-h-2.5 tw-rounded-full",
      e[s.bg]
    ]);
    return (r, d) => (a(), l("div", {
      class: p([i.value, "w-48"])
    }, null, 2));
  }
}), ka = {
  key: 0,
  class: "tw-mr-2 tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-place-self-center tw-rounded-full tw-border-2 tw-border-dorian-gray-100 tw-bg-white tw-p-0.5"
}, $a = ["href", "data-test-id"], Ma = { class: "tw-col-span-1 tw-flex tw-flex-col tw-items-start tw-self-start" }, Ba = { class: "tw-col-span-1 tw-flex tw-flex-col tw-items-end tw-self-end" }, ei = /* @__PURE__ */ c({
  __name: "cl-card-trend",
  props: {
    loading: { type: Boolean, default: !1 },
    href: { default: () => ({
      title: "title",
      url: "nameRoute",
      icon: "",
      navigate: () => {
      }
    }) },
    testId: { default: "" },
    tippy: { default: () => ({
      content: "",
      placement: ""
    }) }
  },
  setup(n) {
    const t = M(!1), e = st(), s = n;
    function i(d) {
      t.value = d;
    }
    const r = k(() => e["footer-left"] && e["footer-right"] ? "tw-grid-cols-2" : "");
    return (d, w) => {
      const u = $t("cl-skeleton-row"), m = ne("tippy");
      return a(), l("div", {
        class: p([t.value ? "hover:tw-shadow-lg" : "tw-shadow", "tw-relative tw-flex tw-h-36 tw-w-full tw-flex-col tw-justify-between tw-rounded-sm tw-bg-white tw-p-6"])
      }, [
        L(h(ht), {
          class: "tw-flex tw-items-center",
          size: "h6"
        }, {
          default: N(() => [
            g(d.$slots, "title", {}, () => [
              s.href.icon ? A((a(), l("div", ka, [
                (a(), D(rt(s.href.icon)))
              ])), [
                [m, s.tippy]
              ]) : x("", !0),
              o("a", {
                class: "tw-text-lg tw-font-semibold tw-text-dorian-gray-500 hover:tw-text-secondary-500",
                href: s.href.url,
                "data-test-id": s.testId,
                onMouseover: w[0] || (w[0] = (v) => i(!0)),
                onMouseleave: w[1] || (w[1] = (v) => i(!1)),
                onClick: w[2] || (w[2] = //@ts-ignore
                (...v) => s.href.navigate && s.href.navigate(...v))
              }, C(s.href.title), 41, $a)
            ]),
            h(e).title ? x("", !0) : (a(), D(h(Lt), {
              key: 0,
              class: p([
                t.value ? "tw-text-secondary-500" : "tw-text-dorian-gray-500",
                "tw-ml-1 tw-inline tw-min-w-5"
              ]),
              width: "20",
              height: "20"
            }, null, 8, ["class"]))
          ]),
          _: 3
        }),
        o("div", {
          class: p(["tw-relative tw-grid tw-gap-4", r.value])
        }, [
          o("div", Ma, [
            s.loading ? (a(), D(h(xt), {
              key: 0,
              class: "tw-w-full"
            }, {
              default: N(() => [
                L(u)
              ]),
              _: 1
            })) : g(d.$slots, "footer-left", { key: 1 })
          ]),
          o("div", Ba, [
            s.loading ? (a(), D(h(xt), {
              key: 0,
              class: "tw-w-full"
            }, {
              default: N(() => [
                L(u, { bg: "light" })
              ]),
              _: 1
            })) : g(d.$slots, "footer-right", { key: 1 })
          ])
        ], 2)
      ], 2);
    };
  }
}), La = ["aria-hidden"], Ha = { class: "tw-relative tw-rounded-lg tw-bg-white tw-shadow dark:tw-bg-light" }, Ia = { class: "tw-flex tw-items-start tw-justify-between tw-border-b tw-border-dorian-gray-50 tw-p-4 dark:tw-border-dorian-gray-100" }, za = ["data-test-id"], Va = { class: "tw-max-h-[70vh] tw-space-y-6 tw-overflow-y-scroll tw-p-6" }, Ta = { class: "tw-flex tw-items-center tw-justify-end tw-space-x-2 tw-border-t tw-border-dorian-gray-50 tw-p-6 dark:tw-border-dorian-gray-100" }, oi = /* @__PURE__ */ c({
  __name: "cl-modal",
  props: {
    visible: { type: Boolean },
    testId: { default: "default-test-id" },
    headerLabel: { default: "Modal" },
    acceptLabel: { default: "Accept" },
    declineLabel: { default: "Decline" },
    size: { default: "md" }
  },
  emits: ["on-close", "on-accept", "on-decline"],
  setup(n, { emit: t }) {
    const e = n, s = M(null);
    G(s, () => w("on-close"));
    const i = k(() => e.visible ? "tw-visible  tw-opacity-1" : "tw-invisible  tw-opacity-0"), r = {
      sm: "tw-max-w-1xl",
      md: "tw-max-w-2xl",
      lg: "tw-max-w-3xl",
      xl: "tw-max-w-4xl",
      xxl: "tw-max-w-5xl"
    }, d = k(() => [r[e.size]]), w = t, u = () => {
      w("on-close");
    }, m = () => {
      w("on-accept");
    }, v = () => {
      w("on-decline");
    };
    return ($, y) => (a(), l("div", {
      tabindex: "-1",
      "aria-hidden": !i.value,
      class: p(["tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-top-0 tw-z-50 tw-max-h-full tw-w-full tw-bg-[#000000]/50 tw-transition-all dark:tw-bg-[#000000]/80", i.value])
    }, [
      o("div", {
        ref_key: "target",
        ref: s,
        class: p(["tw-fixed tw-left-1/2 tw-top-1/2 tw-max-h-full tw-w-full tw--translate-x-1/2 tw--translate-y-1/2", d.value])
      }, [
        o("div", Ha, [
          o("div", Ia, [
            g($.$slots, "header.title", {}, () => [
              L(h(ht), { size: "h4" }, {
                default: N(() => [
                  R(C(e.headerLabel), 1)
                ]),
                _: 1
              })
            ]),
            o("button", {
              type: "button",
              class: "tw-bg-transparent tw-ml-auto tw-inline-flex tw-items-center tw-rounded-md tw-p-1.5 tw-text-sm tw-text-dorian-gray-500 tw-outline-none tw-outline-offset-0 tw-transition-all hover:tw-bg-dorian-gray-50 focus:tw-outline-4 focus:tw-outline-dorian-gray-200/20 active:tw-bg-dorian-gray-100 active:tw-text-dorian-gray-500",
              "data-test-id": `${e.testId}-close`,
              onClick: u
            }, y[0] || (y[0] = [
              o("svg", {
                "aria-hidden": "true",
                class: "tw-h-5 tw-w-5",
                fill: "currentColor",
                viewBox: "0 0 20 20",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                o("path", {
                  "fill-rule": "evenodd",
                  d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                  "clip-rule": "evenodd"
                })
              ], -1),
              o("span", { class: "tw-sr-only" }, "Close modal", -1)
            ]), 8, za)
          ]),
          o("div", Va, [
            g($.$slots, "breadcrumbs"),
            g($.$slots, "default")
          ]),
          o("div", Ta, [
            g($.$slots, "footer.decline", {}, () => [
              L(h(wt), {
                "data-test-id": `${e.testId}-${e.declineLabel}-button`,
                variant: "link-secondary",
                onOnClick: v
              }, {
                default: N(() => [
                  R(C(e.declineLabel), 1)
                ]),
                _: 1
              }, 8, ["data-test-id"])
            ]),
            g($.$slots, "footer.accept", {}, () => [
              L(h(wt), {
                variant: "secondary",
                "data-test-id": `${e.testId}-${e.acceptLabel}-button`,
                onOnClick: m
              }, {
                default: N(() => [
                  R(C(e.acceptLabel), 1)
                ]),
                _: 1
              }, 8, ["data-test-id"])
            ])
          ])
        ])
      ], 2)
    ], 10, La));
  }
}), Sa = { class: "tw-flex tw-items-center" }, ja = { class: "tw-mb-0 tw-w-full tw-py-1 tw-text-base tw-font-normal tw-text-dorian-gray-500" }, si = /* @__PURE__ */ c({
  __name: "cl-dropdown",
  props: {
    title: {},
    position: { default: "bottom" },
    testId: { default: "cl-dropdown-toggle-btn" },
    disabled: { type: Boolean, default: !1 }
  },
  setup(n) {
    const t = n, e = {
      top: "tw-bottom-12",
      bottom: "tw-top-12"
    }, s = M(!1), i = M(null);
    G(i, () => {
      s.value && (s.value = !1);
    });
    const r = k(() => [
      e[t.position],
      s.value ? "tw-opacity-100" : "tw-opacity-0"
    ]);
    return (d, w) => (a(), l("div", {
      ref_key: "target",
      ref: i,
      class: "wrap tw-relative tw-w-fit"
    }, [
      L(h(wt), {
        variant: "secondary",
        "data-test-id": t.testId,
        disabled: d.disabled,
        onClick: w[0] || (w[0] = (u) => s.value = !s.value)
      }, {
        default: N(() => [
          w[2] || (w[2] = o("span", { class: "tw-sr-only" }, "Dropdown", -1)),
          o("div", Sa, [
            R(C(t.title) + " ", 1),
            L(h(ot), {
              class: p(["tw-transition-transform", s.value ? "tw-rotate-180" : "tw-rotate-0"])
            }, null, 8, ["class"])
          ])
        ]),
        _: 1
      }, 8, ["data-test-id", "disabled"]),
      s.value ? (a(), l("div", {
        key: 0,
        class: p(["tw-absolute tw-right-0 tw-z-10 tw-m-1 tw-flex tw-min-w-max tw-rounded-md tw-border tw-border-dorian-gray-100 tw-bg-white tw-shadow-md tw-transition-opacity", r.value]),
        onClick: w[1] || (w[1] = (u) => s.value = !1)
      }, [
        o("ul", ja, [
          g(d.$slots, "default")
        ])
      ], 2)) : x("", !0)
    ], 512));
  }
}), ni = /* @__PURE__ */ c({
  __name: "cl-dropdown-item",
  props: {
    bordered: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["on-click"],
  setup(n, { emit: t }) {
    const e = n, s = k(() => [
      "tw-block tw-cursor-pointer tw-border-b tw-px-4 tw-py-2 tw-text-left",
      e.bordered ? "tw-border-dorian-gray-50" : "tw-border-none",
      e.disabled ? "tw-pointer-events-none tw-text-dorian-gray-200" : "hover:tw-bg-light"
    ]), i = t, r = () => {
      i("on-click");
    };
    return (d, w) => (a(), l("li", {
      class: p(s.value),
      onClick: r
    }, [
      g(d.$slots, "default")
    ], 2));
  }
}), Za = {}, Da = { class: "tw-relative" }, Aa = { class: "tw--mb-px tw-flex tw-flex-wrap tw-text-center" };
function Pa(n, t) {
  return a(), l("div", Da, [
    o("ul", Aa, [
      g(n.$slots, "default")
    ])
  ]);
}
const ai = /* @__PURE__ */ T(Za, [["render", Pa]]), li = /* @__PURE__ */ c({
  __name: "cl-tabs-item",
  props: {
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["on-click"],
  setup(n, { emit: t }) {
    const e = n, { active: s, disabled: i } = j(e), r = k(() => [
      "tw-mb-2 tw-mr-4 tw-select-none",
      i.value ? "tw-pointer-events-none tw-text-dorian-gray-200" : "tw-text-dorian-gray-500 hover:tw-cursor-pointer",
      s.value ? "hover:tw-cursor-default" : "hover:tw-cursor-pointer"
    ]), d = k(() => [
      "tw-inline-block tw-border-b-2 tw-text-base tw-font-medium",
      s.value ? "tw-border-secondary-500 tw-text-secondary-500 hover:tw-cursor-default" : "tw-border-secondary-500/0 hover:tw-border-secondary-500"
    ]), w = t, u = () => {
      w("on-click");
    };
    return (m, v) => (a(), l("li", {
      class: p(r.value),
      onClick: u
    }, [
      o("span", {
        class: p(d.value)
      }, [
        g(m.$slots, "default")
      ], 2)
    ], 2));
  }
}), ri = /* @__PURE__ */ c({
  __name: "cl-badge",
  props: {
    variant: { default: "info" },
    size: { default: "base" }
  },
  setup(n) {
    const t = {
      info: "tw-bg-info-100",
      warning: "tw-bg-warning-200",
      danger: "tw-bg-danger-100"
    }, e = {
      sm: "tw-px-1",
      base: "tw-px-2 tw-py-1"
    }, s = n, i = k(() => [
      "tw-inline-flex tw-items-center tw-rounded",
      t[s.variant],
      e[s.size]
    ]);
    return (r, d) => (a(), l("span", {
      class: p([i.value, ""])
    }, [
      g(r.$slots, "default")
    ], 2));
  }
}), ii = /* @__PURE__ */ c({
  __name: "cl-badge-label",
  setup(n) {
    const t = k(() => [
      "tw-m-1 tw-rounded tw-bg-white tw-px-1 tw-pt-0.5 tw-text-xs tw-font-normal tw-uppercase"
    ]);
    return (e, s) => (a(), l("span", {
      class: p(t.value)
    }, [
      g(e.$slots, "default")
    ], 2));
  }
}), Ea = { class: "tw-mb-3 tw-mr-3 tw-inline-flex tw-h-12 tw-w-48 tw-items-center tw-justify-between tw-rounded tw-border tw-border-dorian-gray-200 tw-bg-white" }, Na = { class: "tw-ml-1 tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center" }, Oa = { class: "tw-w-[118px] tw-px-1" }, Fa = { class: "tw-w-[118px]" }, Ra = { class: "tw-text-xs tw-font-bold tw-text-dorian-gray-500" }, Ua = { class: "tw-flex tw-justify-between tw-text-xs tw-text-dorian-gray-500" }, Wa = { class: "tw-mr-2 tw-flex tw-h-6 tw-w-6 tw-cursor-pointer tw-items-center tw-justify-end" }, Ga = ["href", "data-test-id"], di = /* @__PURE__ */ c({
  __name: "cl-email-attachment",
  props: {
    link: {},
    name: {},
    extension: {},
    size: {},
    testId: { default: "cl-attachment-download-link" }
  },
  setup(n) {
    const t = n, e = k(() => `${t.name.substring(0, 16)}...`);
    return (s, i) => (a(), l("div", Ea, [
      o("div", Na, [
        L(h(Bo), {
          width: "24",
          height: "24"
        })
      ]),
      o("div", Oa, [
        o("div", Fa, [
          L(h(Vt), {
            id: t.name,
            text: t.name
          }, {
            default: N(() => [
              o("span", Ra, C(e.value), 1)
            ]),
            _: 1
          }, 8, ["id", "text"])
        ]),
        o("div", Ua, [
          o("span", null, C(t.extension), 1),
          o("span", null, C(t.size), 1)
        ])
      ]),
      o("div", Wa, [
        o("a", {
          href: t.link,
          "data-test-id": t.testId,
          target: "_blank",
          class: "tw-text-dorian-gray-500 hover:tw-text-secondary-500"
        }, [
          L(h(ko), {
            width: "18",
            height: "18"
          })
        ], 8, Ga)
      ])
    ]));
  }
}), Qa = { class: "tw-inline-flex tw-cursor-pointer tw-items-center tw-rounded-md tw-p-2" }, wi = /* @__PURE__ */ c({
  __name: "cl-switcher",
  props: {
    options: { default: () => ["Yes", "No"] },
    selectedValue: { type: Boolean }
  },
  emits: ["update:selected"],
  setup(n, { emit: t }) {
    const e = n, s = t, i = M(e.selectedValue);
    return S(i, (r) => {
      s("update:selected", r);
    }), S(
      () => e.selectedValue,
      () => {
        i.value = e.selectedValue;
      }
    ), (r, d) => (a(), l("label", Qa, [
      A(o("input", {
        "onUpdate:modelValue": d[0] || (d[0] = (w) => i.value = w),
        type: "checkbox",
        class: "tw-peer tw-hidden"
      }, null, 512), [
        [q, i.value]
      ]),
      o("div", {
        class: p([!r.selectedValue && "dark:tw-text-dorian-gray-300", "tw-rounded-l-md tw-bg-dorian-gray-100 tw-px-4 tw-py-2 tw-font-bold tw-text-white peer-checked:tw-bg-secondary-500"])
      }, C(r.options[0]), 3),
      o("div", {
        class: p([r.selectedValue && "dark:tw-text-dorian-gray-300", "tw-rounded-r-md tw-border-secondary-500 tw-bg-secondary-500 tw-px-4 tw-py-2 tw-font-bold tw-text-white peer-checked:tw-bg-dorian-gray-100"])
      }, C(r.options[1]), 3)
    ]));
  }
}), Ka = (n, t) => {
  const e = (r) => r.split(" ").map(
    (u) => u.charAt(0).toUpperCase() + u.slice(1).toLowerCase()
  ).join(" "), s = (r, d) => {
    let w = d;
    return r.mspName && (w = w.replace(/^Msp$/, r.mspName)), r.customerName && (w = w.replace(/^Customer$/, r.customerName)), r.domainName && (w = w.replace(/^Domain$/, r.domainName)), r.userName && (w = w.replace(/^User$/, r.userName)), w;
  }, i = `${n.parentPath}${t}`.split("/");
  return i.map((r) => s(n, e(r))).reduce((r, d, w) => {
    if (w === 0)
      return [];
    const u = i[w];
    return [
      ...r,
      {
        text: /^\d+$/.test(d) ? n.title : e(
          d.replace(/[_ -]/g, " ").replace(/%20/g, " ")
        ),
        to: w === 1 ? `/${u}` : `${r[w - 2].to}/${u}`
      }
    ];
  }, []);
}, qa = { class: "tw-m-0 tw-flex tw-list-none tw-flex-wrap tw-p-0" }, Ja = ["onClick"], ci = /* @__PURE__ */ c({
  __name: "cl-breadcrumbs",
  props: {
    pageMeta: {},
    routePath: {}
  },
  emits: ["on-click"],
  setup(n, { emit: t }) {
    const e = n, s = k(() => Ka(e.pageMeta, e.routePath)), i = t, r = (d) => {
      i("on-click", d);
    };
    return (d, w) => (a(), l("ol", qa, [
      (a(!0), l(V, null, Z(s.value, (u) => (a(), l("li", {
        key: u.to,
        class: "tw-text-md :after:tw-font-normal after:tw-pl-1 after:tw-pr-1 after:tw-text-dorian-gray-500 [&:not(:last-child)]:tw-cursor-pointer [&:not(:last-child)]:tw-font-bold [&:not(:last-child)]:tw-text-secondary-500 [&:not(:last-child)]:after:tw-content-['/']",
        onClick: (m) => r(u.to)
      }, C(u.text), 9, Ja))), 128))
    ]));
  }
}), Xa = { class: "tw-flex tw-items-center tw-gap-2" }, Ya = ["id", "value", "data-test-id", "disabled"], tl = ["for"], ui = /* @__PURE__ */ c({
  __name: "cl-checkbox",
  props: {
    id: {},
    value: { type: Boolean },
    modelValue: { type: [Boolean, Array] },
    round: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    testId: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: t }) {
    const e = n, s = t, i = st(), r = k({
      get() {
        return e.modelValue;
      },
      set(d) {
        s("update:modelValue", d);
      }
    });
    return (d, w) => (a(), l("div", Xa, [
      A(o("input", {
        id: e.id,
        "onUpdate:modelValue": w[0] || (w[0] = (u) => r.value = u),
        type: "checkbox",
        class: p(["tw-h-5 tw-w-5 tw-cursor-pointer tw-rounded tw-border-2 tw-border-solid tw-border-dorian-gray-500 tw-bg-white tw-text-secondary-500 checked:tw-border-secondary-500 focus:tw-ring-secondary-500 focus:tw-ring-offset-white disabled:tw-border-dorian-gray-100 disabled:tw-text-dorian-gray-100 disabled:checked:tw-border-dorian-gray-100 dark:tw-border-dorian-gray-400", {
          "tw-rounded-full": d.round
        }]),
        value: d.value,
        "data-test-id": d.testId,
        disabled: d.disabled
      }, null, 10, Ya), [
        [q, r.value]
      ]),
      h(i).default ? (a(), l("label", {
        key: 0,
        for: d.id,
        class: "tw-mb-0 tw-cursor-pointer"
      }, [
        g(d.$slots, "default")
      ], 8, tl)) : x("", !0)
    ]));
  }
}), el = { class: "tw-flex tw-flex-row" }, ol = ["data-test-id"], sl = ["id", "name", "checked", "disabled", "onChange"], nl = ["for", "data-test-id"], hi = /* @__PURE__ */ c({
  __name: "cl-form-radio-group",
  props: {
    dataTestId: { default: "" },
    id: { default: "" },
    options: {},
    selectedValue: { type: [String, Boolean, Number], default: void 0 },
    button: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    size: { default: "medium" }
  },
  emits: ["update:selected"],
  setup(n, { emit: t }) {
    const e = n, s = t, i = {
      radio: "tw-bg-white tw-border-dorian-gray-500 tw-border-dorian-gray-70 tw-my-2 tw-ml-4 tw-mr-2 tw-h-5 tw-w-5 tw-cursor-pointer tw-border-2 tw-border-solid tw-text-secondary-500 checked:tw-border-secondary-500 focus:tw-ring-secondary-500 focus:tw-ring-offset-white",
      button: "tw-sr-only tw-invisible tw-peer"
    }, r = {
      radio: "tw-text-base tw-cursor-pointer tw-m-0",
      button: "tw-m-0 tw-text-secondary-500 tw-font-bold peer-checked:tw-bg-secondary-500 tw-border-secondary-500 peer-checked:tw-text-white tw-flex tw-px-3 tw-py-2 tw-cursor-pointer hover:tw-bg-secondary-200 hover:tw-text-secondary-600"
    }, d = M(e.selectedValue), w = M(
      e.id ? e.id : (Math.random() + 1).toString(36).substring(2)
    ), u = k(() => e.button ? [i.button] : [i.radio]), m = k(() => e.button ? [r.button] : [r.radio]);
    S(
      () => e.selectedValue,
      () => {
        d.value = e.selectedValue;
      }
    );
    const v = ($) => {
      s("update:selected", $);
    };
    return ($, y) => (a(), l("div", el, [
      (a(!0), l(V, null, Z(e.options, (B, I) => (a(), l("div", {
        key: I,
        class: "tw-flex tw-items-center",
        "data-test-id": e.dataTestId
      }, [
        o("input", {
          id: `${w.value}-${B.value}`,
          type: "radio",
          name: `${w.value}-name`,
          class: p(u.value),
          checked: B.value === d.value,
          disabled: e.disabled,
          onChange: (nt) => v(B.value)
        }, null, 42, sl),
        o("label", {
          for: `${w.value}-${B.value}`,
          "data-test-id": `${e.dataTestId}-${B.label}`,
          class: p([
            m.value,
            {
              "tw-text-sm": e.size === "small",
              "tw-rounded-l tw-border-2": I === 0 && e.button,
              "tw-rounded-r tw-border-b-2 tw-border-r-2 tw-border-t-2": I === $.options.length - 1 && e.button,
              "tw-border-b-2 tw-border-r-2 tw-border-t-2": I !== $.options.length - 1 && I !== 0 && e.button
            }
          ])
        }, C(B.label), 11, nl)
      ], 8, ol))), 128))
    ]));
  }
}), al = { class: "tw-flex-grow" }, ll = { class: "tw-text-lg tw-font-semibold" }, pi = /* @__PURE__ */ c({
  __name: "cl-toast",
  props: {
    id: {},
    title: {},
    message: {},
    variant: { default: "success" }
  },
  emits: ["on-close"],
  setup(n, { emit: t }) {
    const e = n, s = t, i = (d) => {
      s("on-close", d);
    }, r = k(() => e.variant === "success");
    return (d, w) => (a(), l("div", {
      class: p([
        "tw-z-[55] tw-flex tw-w-80 tw-items-start tw-justify-between tw-gap-3 tw-rounded-sm tw-border-2 tw-p-3",
        r.value ? "tw-border-success-500 tw-bg-success-100" : "tw-border-danger-500 tw-bg-danger-100"
      ]),
      role: "alert"
    }, [
      o("div", {
        class: p(r.value ? "tw-text-success-500" : "tw-text-danger-500")
      }, [
        L(h(Ht))
      ], 2),
      o("div", al, [
        o("div", ll, C(d.title), 1),
        o("div", null, C(d.message), 1)
      ]),
      o("button", {
        class: "tw-inline-flex",
        "aria-label": "Close",
        onClick: w[0] || (w[0] = (u) => i(d.id))
      }, [
        L(h(It))
      ])
    ], 2));
  }
}), rl = ["data-test-id"], il = { class: "tw-relative tw-flex tw-min-h-[58px] tw-w-full tw-items-center tw-justify-start tw-rounded-t tw-bg-aside-300 tw-p-2 dark:tw-bg-dorian-gray-100" }, dl = { class: "tw-text-lg tw-font-medium tw-text-white dark:tw-text-dorian-gray-500" }, wl = { class: "tw-relative tw-p-1 tw-pt-0" }, cl = { class: "tw-mb-0 tw-w-full tw-text-base tw-font-normal tw-text-dorian-gray-500" }, ul = {
  key: 0,
  class: "tw-relative tw-border-t tw-border-t-dorian-gray-50 tw-px-2 tw-py-2 dark:tw-border-t-dorian-gray-100"
}, hl = { class: "tw-relative tw-p-1 tw-pt-0" }, pl = { class: "tw-mb-0 tw-w-full tw-text-base tw-font-normal tw-text-dorian-gray-500" }, fi = /* @__PURE__ */ c({
  __name: "cl-header-dropdown",
  props: {
    dataTestId: { default: "" }
  },
  setup(n) {
    const t = n, e = M(!1), s = M(null);
    return G(s, () => {
      e.value && (e.value = !1);
    }), (i, r) => (a(), l("div", {
      ref_key: "target",
      ref: s,
      class: "tw-relative tw-z-20 tw-h-12 tw-w-12"
    }, [
      o("button", {
        class: "tw-relative tw-z-30 tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full tw-bg-white tw-text-dorian-gray-500 tw-shadow-md tw-outline-0 -tw-outline-offset-4 tw-outline-aside-300 hover:tw-text-dorian-gray-300 focus:tw-outline-2 focus-visible:tw-outline-2 active:tw-shadow-none",
        type: "button",
        "data-test-id": t.dataTestId,
        onClick: r[0] || (r[0] = (d) => e.value = !e.value)
      }, [
        r[2] || (r[2] = o("span", { class: "tw-sr-only" }, "Account Dropdown", -1)),
        L(h(fs))
      ], 8, rl),
      e.value ? (a(), l("div", {
        key: 0,
        class: "tw-absolute tw-right-[-6px] tw-top-[-6px] tw-z-20 tw-flex tw-min-w-[368px] tw-flex-col tw-rounded tw-border-dorian-gray-100 tw-bg-white tw-shadow-md",
        onClick: r[1] || (r[1] = (d) => e.value = !1)
      }, [
        o("div", il, [
          o("span", dl, [
            g(i.$slots, "title")
          ])
        ]),
        o("div", wl, [
          o("ul", cl, [
            g(i.$slots, "products")
          ])
        ]),
        i.$slots.appearance ? (a(), l("div", ul, [
          g(i.$slots, "appearance")
        ])) : x("", !0),
        o("div", hl, [
          o("ul", pl, [
            g(i.$slots, "links")
          ])
        ])
      ])) : x("", !0)
    ], 512));
  }
}), fl = { class: "tw-relative tw-my-0.5 tw-flex tw-h-auto tw-w-full tw-items-center tw-justify-start tw-bg-white" }, gl = ["href", "data-test-id"], bl = { class: "tw-relative tw-flex tw-h-full tw-w-full tw-items-center tw-justify-between" }, vl = { class: "tw-text-lg tw-font-bold tw-text-dorian-gray-500" }, gi = /* @__PURE__ */ c({
  __name: "cl-header-dropdown-product",
  props: {
    link: {},
    active: { type: Boolean, default: !1 },
    label: { default: "" },
    dataTestId: { default: "" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("li", fl, [
      o("a", {
        href: t.link,
        "data-test-id": t.dataTestId,
        target: "_blank",
        class: p(["tw-inline-flex tw-h-full tw-w-full tw-rounded tw-bg-white tw-px-2 tw-py-4 tw-no-underline tw-transition-colors hover:tw-bg-dorian-gray-50/40 dark:hover:tw-bg-dorian-gray-100/60", {
          "tw-pointer-events-none tw-border tw-border-secondary-500 tw-bg-secondary-50": t.active
        }])
      }, [
        o("figure", bl, [
          g(e.$slots, "default"),
          o("figcaption", vl, [
            R(C(t.label) + " ", 1),
            t.active ? (a(), D(h(Ls), { key: 0 })) : x("", !0)
          ])
        ])
      ], 10, gl)
    ]));
  }
}), ml = { class: "tw-relative tw-my-0.5 tw-flex tw-h-auto tw-w-full tw-items-center tw-justify-start tw-border-t tw-border-t-dorian-gray-50 tw-bg-white tw-pb-2 tw-pt-2 dark:tw-border-t-dorian-gray-100" }, _l = ["href", "target", "data-test-id"], yl = { class: "tw-relative tw-inline-flex tw-items-center tw-justify-start" }, xl = { class: "tw-font-normal tw-text-dorian-gray-500" }, Cl = { class: "tw-ml-4 tw-font-normal tw-text-dorian-gray-500" }, bi = /* @__PURE__ */ c({
  __name: "cl-header-dropdown-link",
  props: {
    label: {},
    link: {},
    target: { default: "_self" },
    dataTestId: { default: "" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("li", ml, [
      o("a", {
        class: "tw-inline-flex tw-h-full tw-w-full tw-rounded tw-bg-white tw-px-2 tw-py-2 tw-no-underline tw-transition-colors hover:tw-bg-dorian-gray-50/40 dark:hover:tw-bg-dorian-gray-100/60",
        href: t.link,
        target: t.target,
        "data-test-id": t.dataTestId
      }, [
        o("div", yl, [
          o("span", xl, [
            g(e.$slots, "default")
          ]),
          o("span", Cl, C(e.label), 1)
        ])
      ], 8, _l)
    ]));
  }
}), kl = ["id", "name", "rows", "maxlength", "autofocus", "placeholder", "disabled", "readonly", "data-test-id"], $l = "focus:tw-border-secondary-500 focus:tw-ring-4 focus:tw-ring-secondary-500/10", Ml = "disabled:tw-cursor-not-allowed disabled:tw-bg-dorian-gray-50 disabled:tw-text-dorian-gray-500/50 disabled:tw-outline-none", Bl = "read-only:tw-cursor-default read-only:tw-bg-dorian-gray-50 read-only:tw-text-dorian-gray-500/50 read-only:tw-outline-none", vi = /* @__PURE__ */ c({
  __name: "cl-form-textarea",
  props: {
    id: {},
    name: {},
    value: {},
    placeholder: { default: "" },
    state: { type: [Boolean, null], default: null },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    autofocus: { type: Boolean, default: !1 },
    testId: { default: "" },
    rows: { default: 3 },
    maxLength: { default: void 0 },
    size: { default: "medium" }
  },
  emits: ["update:value", "on-blur"],
  setup(n, { emit: t }) {
    const e = n, s = t, i = M(e.value), r = {
      small: "tw-text-sm tw-py-1 tw-px-3",
      medium: "tw-text-base tw-py-2 tw-px-3",
      large: "tw-text-lg tw-py-3 tw-px-3"
    }, d = {
      none: "tw-border-dorian-gray-100/80",
      valid: "tw-border-success-500",
      error: "tw-border-danger-500"
    }, w = k(() => [
      r[e.size],
      e.state === null ? d.none : e.state ? d.valid : d.error,
      $l,
      Ml,
      Bl
    ]);
    S(
      () => e.value,
      () => {
        i.value = e.value;
      }
    ), S(i, (m) => {
      s("update:value", m);
    });
    const u = () => {
      s("on-blur");
    };
    return (m, v) => A((a(), l("textarea", {
      id: e.id,
      "onUpdate:modelValue": v[0] || (v[0] = ($) => i.value = $),
      class: p(["tw-block tw-w-full tw-rounded tw-border tw-bg-white tw-text-dorian-gray-500 tw-outline-none tw-ring-offset-1 tw-transition-all", [w.value]]),
      name: e.name,
      rows: e.rows,
      maxlength: e.maxLength,
      autofocus: e.autofocus,
      placeholder: e.placeholder,
      disabled: e.disabled,
      readonly: e.readonly,
      "data-test-id": e.testId,
      onBlur: u
    }, null, 42, kl)), [
      [ct, i.value]
    ]);
  }
}), Ll = ["value"], Hl = /* @__PURE__ */ c({
  __name: "cl-form-select-options",
  props: {
    options: {}
  },
  setup(n) {
    return (t, e) => (a(!0), l(V, null, Z(t.options, (s) => (a(), l("option", {
      key: s.value,
      value: s.value
    }, C(s.text), 9, Ll))), 128));
  }
}), Il = ["label"], zl = ["value"], Vl = /* @__PURE__ */ c({
  __name: "cl-form-select-options-group",
  props: {
    options: {}
  },
  setup(n) {
    return (t, e) => (a(!0), l(V, null, Z(t.options, (s, i) => (a(), l("optgroup", {
      key: i,
      label: s.label
    }, [
      (a(!0), l(V, null, Z(s.options, (r) => (a(), l("option", {
        key: r.value,
        value: r.value
      }, C(r.text), 9, zl))), 128))
    ], 8, Il))), 128));
  }
}), Tl = ["id", "name", "data-test-id", "autofocus", "options", "disabled"], Sl = "focus:tw-border-secondary-500 focus:tw-ring-4 focus:tw-ring-secondary-500/10", jl = "disabled:tw-cursor-not-allowed disabled:tw-bg-dorian-gray-50 disabled:tw-text-dorian-gray-500/50 disabled:tw-outline-none", mi = /* @__PURE__ */ c({
  __name: "cl-form-select",
  props: {
    id: {},
    name: {},
    value: {},
    testId: { default: "" },
    autofocus: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    options: {},
    size: { default: "medium" }
  },
  emits: ["update:value", "change"],
  setup(n, { emit: t }) {
    const e = n, s = t, i = M(e.value), r = (v) => !!(v && v[0].options && v[0].label), d = (v) => !!(v && v[0].text && v[0].value), w = {
      small: "tw-text-sm tw-py-1 tw-px-3",
      medium: "tw-text-base tw-py-2 tw-px-3",
      large: "tw-text-lg tw-py-3 tw-px-3"
    }, u = k(() => [w[e.size], Sl, jl]);
    S(
      () => e.value,
      () => {
        i.value = e.value;
      }
    ), S(i, (v) => {
      s("update:value", v);
    });
    const m = (v) => {
      s("change", v);
    };
    return (v, $) => A((a(), l("select", {
      id: v.id,
      "onUpdate:modelValue": $[0] || ($[0] = (y) => i.value = y),
      class: p(["tw-block tw-w-full tw-rounded tw-border tw-border-dorian-gray-100 tw-bg-white tw-text-dorian-gray-500 tw-outline-none tw-ring-offset-1 tw-transition-all", [u.value]]),
      name: v.name,
      "data-test-id": v.testId,
      autofocus: v.autofocus,
      options: v.options,
      disabled: v.disabled,
      onChange: $[1] || ($[1] = (y) => m(i.value))
    }, [
      r(v.options) ? (a(), D(Vl, {
        key: 0,
        options: v.options
      }, null, 8, ["options"])) : x("", !0),
      d(v.options) ? (a(), D(Hl, {
        key: 1,
        options: v.options
      }, null, 8, ["options"])) : x("", !0)
    ], 42, Tl)), [
      [kt, i.value]
    ]);
  }
}), Zl = { class: "tw-relative tw-overflow-auto" }, Dl = { class: "tw-flex tw-w-full tw-items-center tw-text-center" }, Al = ["onClick"], _i = /* @__PURE__ */ c({
  __name: "cl-stepper",
  props: {
    steps: {}
  },
  emits: ["on-Click"],
  setup(n, { emit: t }) {
    const e = n, s = t, i = (r) => {
      s("on-Click", r);
    };
    return (r, d) => (a(), l("div", Zl, [
      o("ol", Dl, [
        (a(!0), l(V, null, Z(e.steps, (w, u) => (a(), l("li", {
          key: w.index,
          class: p(["tw-relative tw-flex tw-items-center", {
            "after:tw-border-1 after:tw-mx-6 after:tw-hidden after:tw-h-1 after:tw-w-full after:tw-border-b after:tw-border-dorian-gray-100 sm:after:tw-inline-block sm:after:tw-content-[''] md:tw-w-full xl:after:tw-mx-10": u !== e.steps.length - 1
          }])
        }, [
          o("span", {
            class: p(["tw-relative tw-flex tw-items-center tw-text-dorian-gray-500", {
              "after:tw-mx-2 after:tw-text-dorian-gray-100 after:tw-content-['/'] sm:after:tw-hidden": u !== e.steps.length - 1
            }])
          }, [
            w.completed ? (a(), D(h(vs), {
              key: 0,
              width: "16px",
              height: "16px",
              class: "tw-select-none tw-text-secondary-500"
            })) : (a(), l("span", {
              key: 1,
              class: p(["tw-select-none tw-text-base tw-font-medium", {
                "tw-text-secondary-500": w.current
              }])
            }, C(w.index), 3)),
            o("span", {
              class: p(["tw-ml-2.5 tw-inline-flex tw-whitespace-nowrap tw-text-base tw-font-medium tw-underline-offset-1 hover:tw-cursor-pointer hover:tw-underline", {
                "tw-text-dorian-gray-200": w.completed,
                "tw-text-secondary-500": w.current,
                "tw-pointer-events-none": !w.actionable
              }]),
              onClick: (m) => i(w.index)
            }, C(w.label), 11, Al)
          ], 2)
        ], 2))), 128))
      ])
    ]));
  }
}), Pl = ["id"], El = {
  key: 0,
  class: "w-relative tw-mb-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-2"
}, Nl = {
  key: 0,
  class: "w-relative tw-col-span-1 tw-mb-4 tw-flex tw-justify-start"
}, Ol = ["src"], Fl = { class: "w-relative tw-col-span-1 tw-flex tw-justify-start md:tw-justify-end" }, Rl = { class: "tw-flex tw-flex-col" }, Ul = {
  key: 0,
  class: "tw-mb-2 tw-text-base tw-font-normal tw-text-white dark:tw-text-dorian-gray-500"
}, Wl = ["href", "data-test-id"], Gl = { class: "tw-inline-flex tw-h-full tw-flex-col tw-justify-between" }, Ql = { class: "tw-inline-flex tw-h-6 tw-flex-row tw-items-center" }, Kl = ["src"], ql = { class: "tw-ml-2 tw-text-sm tw-font-semibold tw-text-white dark:tw-text-dorian-gray-500" }, Jl = { class: "tw-text-xs tw-font-normal tw-text-white dark:tw-text-dorian-gray-500" }, Xl = { class: "tw-relative tw-flex tw-flex-col tw-items-center" }, Yl = {
  key: 0,
  class: "tw-text-white dark:tw-text-dorian-gray-500"
}, yi = /* @__PURE__ */ c({
  __name: "cl-footer",
  props: {
    logo: {},
    id: { default: "app-footer" },
    products: { default: () => [] },
    version: { default: "" }
  },
  setup(n) {
    const t = n;
    return (e, s) => (a(), l("footer", {
      id: t.id,
      class: "tw-relative tw-bg-[#374b61] tw-px-4 tw-py-8 tw-text-white dark:tw-bg-dorian-gray-100 dark:tw-text-dorian-gray-500"
    }, [
      t.logo || t.products.length ? (a(), l("div", El, [
        t.logo ? (a(), l("div", Nl, [
          o("img", {
            class: "tw-max-h-[90px] tw-w-auto",
            alt: "company logo",
            src: t.logo
          }, null, 8, Ol)
        ])) : x("", !0),
        o("div", Fl, [
          o("div", Rl, [
            t.products.length > 0 ? (a(), l("div", Ul, C("Other Products"))) : x("", !0),
            (a(!0), l(V, null, Z(t.products, (i, r) => (a(), l("div", {
              key: r,
              class: "tw-mb-2 tw-h-14 tw-w-[260px] tw-rounded-sm tw-border tw-border-dorian-gray-500/5 tw-bg-[#47647d] tw-p-1.5 dark:tw-bg-white"
            }, [
              o("a", {
                href: i.link,
                "data-test-id": `footer-product-${i.title.toLowerCase()}`,
                target: "_blank",
                class: "tw-inline-flex tw-h-full tw-w-full tw-justify-between"
              }, [
                o("div", Gl, [
                  o("div", Ql, [
                    o("img", {
                      src: i.icon,
                      class: "tw-h-6 tw-w-auto"
                    }, null, 8, Kl),
                    o("span", ql, C(i.title), 1)
                  ]),
                  o("div", Jl, C(i.description), 1)
                ]),
                s[0] || (s[0] = o("div", { class: "tw-inline-flex tw-h-full tw-items-center tw-text-sm tw-font-bold tw-text-white dark:tw-text-dorian-gray-500" }, C("Try Now"), -1))
              ], 8, Wl)
            ]))), 128))
          ])
        ])
      ])) : x("", !0),
      o("div", Xl, [
        s[1] || (s[1] = o("div", { class: "tw-text-white dark:tw-text-dorian-gray-500" }, C(" "), -1)),
        e.version ? (a(), l("div", Yl, C(`v ${t.version}`), 1)) : x("", !0)
      ])
    ], 8, Pl));
  }
}), tr = { class: "tw-inline-flex tw-h-8 tw-items-center tw-justify-between tw-rounded-2xl tw-border-none tw-bg-secondary-200 tw-pl-2 tw-pr-1.5" }, er = { class: "tw-text-base tw-text-dorian-gray-500" }, or = { class: "tw-font-bold" }, sr = { class: "tw-pl-1 tw-font-normal" }, xi = /* @__PURE__ */ c({
  __name: "cl-active-filter",
  props: {
    label: {},
    value: {},
    withClose: { type: Boolean, default: !0 }
  },
  emits: ["remove"],
  setup(n, { emit: t }) {
    const e = n, s = t, i = () => {
      s("remove");
    };
    return (r, d) => (a(), l("span", tr, [
      o("span", er, [
        o("span", or, C(e.label), 1),
        o("span", sr, C(e.value), 1)
      ]),
      e.withClose ? (a(), l("span", {
        key: 0,
        role: "button",
        class: "tw-ml-2 tw-inline-flex tw-h-5 tw-w-5 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-bg-secondary-500 tw-text-white tw-transition-colors hover:tw-bg-secondary-400",
        onClick: i
      }, [
        L(h(It), {
          height: "16px",
          width: "16px"
        })
      ])) : x("", !0)
    ]));
  }
}), nr = { class: "tw-relative" }, ar = { class: "tw-inline-flex tw-cursor-pointer tw-items-center" }, lr = { class: "tw-text-sm tw-font-medium tw-text-dorian-gray-500" }, Ci = /* @__PURE__ */ c({
  __name: "cl-toggle",
  props: {
    value: { type: Boolean, default: !1 }
  },
  emits: ["update:value"],
  setup(n, { emit: t }) {
    const e = n, { value: s } = j(e), i = k({
      get() {
        return s.value;
      },
      set(d) {
        r("update:value", d);
      }
    }), r = t;
    return (d, w) => (a(), l("div", nr, [
      o("label", ar, [
        A(o("input", {
          "onUpdate:modelValue": w[0] || (w[0] = (u) => i.value = u),
          type: "checkbox",
          class: "tw-peer tw-sr-only"
        }, null, 512), [
          [q, i.value]
        ]),
        w[1] || (w[1] = o("div", { class: "tw-peer tw-relative tw-h-6 tw-w-11 tw-rounded-full tw-bg-dorian-gray-300 after:tw-absolute after:tw-start-[2px] after:tw-top-[2px] after:tw-h-5 after:tw-w-5 after:tw-rounded-full after:tw-bg-white after:tw-transition-all after:tw-content-[''] peer-checked:tw-bg-secondary-500 peer-checked:after:tw-translate-x-full peer-checked:after:tw-border-white peer-focus:tw-outline-none" }, null, -1)),
        o("span", lr, [
          g(d.$slots, "default")
        ])
      ])
    ]));
  }
}), rr = { class: "tw-mb-4 tw-grid tw-grid-cols-1 tw-gap-2" }, ir = { class: "tw-col-span-1 tw-overflow-x-auto tw-shadow" }, ki = /* @__PURE__ */ c({
  __name: "cl-table-wrapper",
  props: {
    className: {}
  },
  setup(n) {
    const t = n, { className: e } = j(t);
    return (s, i) => (a(), l("div", {
      class: p(["tw-relative tw-my-4 tw-p-4", h(e)])
    }, [
      g(s.$slots, "before"),
      o("div", rr, [
        o("div", ir, [
          g(s.$slots, "table")
        ])
      ]),
      g(s.$slots, "after")
    ], 2));
  }
}), $i = /* @__PURE__ */ c({
  __name: "cl-table",
  props: {
    className: {}
  },
  setup(n) {
    const t = n, { className: e } = j(t);
    return (s, i) => (a(), l("table", U({
      class: ["tw-w-full tw-rounded tw-text-left tw-text-base tw-shadow dark:tw-border dark:tw-border-solid dark:tw-border-dorian-gray-100/80 dark:tw-shadow-none", h(e)]
    }, s.$attrs), [
      g(s.$slots, "default")
    ], 16));
  }
}), Mi = /* @__PURE__ */ c({
  __name: "cl-thead",
  props: {
    className: {}
  },
  setup(n) {
    const t = n, { className: e } = j(t);
    return (s, i) => (a(), l("thead", U({
      class: ["tw-bg-white", h(e)]
    }, s.$attrs), [
      g(s.$slots, "default")
    ], 16));
  }
}), Bi = /* @__PURE__ */ c({
  __name: "cl-tbody",
  props: {
    className: {}
  },
  setup(n) {
    const t = n, { className: e } = j(t);
    return (s, i) => (a(), l("tbody", U({ class: h(e) }, s.$attrs), [
      g(s.$slots, "default")
    ], 16));
  }
}), Li = /* @__PURE__ */ c({
  __name: "cl-tr",
  props: {
    tableTarget: { default: "tbody" },
    zebra: { type: Boolean, default: !1 },
    className: { default: void 0 },
    active: { type: Boolean, default: !1 }
  },
  setup(n) {
    const t = n, e = {
      thead: "",
      tbody: "tw-border-b tw-border-dorian-gray-100/80 tw-h-9 hover:tw-bg-secondary-50 dark:hover:tw-bg-dorian-gray-100"
    }, { className: s, zebra: i, tableTarget: r, active: d } = j(t), w = k(() => {
      const m = (() => d.value ? "tw-bg-secondary-200" : i.value ? "tw-bg-light" : "tw-bg-white")();
      return [e[r.value], m, s.value];
    });
    return (u, m) => (a(), l("tr", U({ class: w.value }, u.$attrs), [
      g(u.$slots, "default")
    ], 16));
  }
}), Hi = /* @__PURE__ */ c({
  __name: "cl-th",
  props: {
    className: {}
  },
  setup(n) {
    const t = n, { className: e } = j(t);
    return (s, i) => (a(), l("th", U({
      class: ["tw-whitespace-nowrap tw-px-2 tw-py-1.5 tw-font-bold", h(e)]
    }, s.$attrs), [
      g(s.$slots, "default")
    ], 16));
  }
}), Ii = /* @__PURE__ */ c({
  __name: "cl-td",
  props: {
    className: {}
  },
  setup(n) {
    const t = n, { className: e } = j(t);
    return (s, i) => (a(), l("td", U({
      class: ["tw-whitespace-nowrap tw-px-2 tw-py-1.5 tw-font-normal", h(e)]
    }, s.$attrs), [
      g(s.$slots, "default")
    ], 16));
  }
}), zi = /* @__PURE__ */ c({
  __name: "cl-tr-skeleton",
  props: {
    rows: {},
    className: {}
  },
  setup(n) {
    const t = n, { rows: e } = j(t);
    return (s, i) => (a(!0), l(V, null, Z(h(e), (r, d) => (a(), l("tr", {
      key: d,
      class: p(["tw-h-9 tw-border-b tw-border-dorian-gray-100/80 hover:tw-bg-secondary-50 dark:hover:tw-bg-dorian-gray-100", "tw-bg-white"])
    }, [
      (a(!0), l(V, null, Z(r, (w) => (a(), l("td", {
        key: r[w],
        class: "h-2 bg-slate-200 rounded tw-animate-pulse tw-whitespace-nowrap tw-px-2"
      }, i[0] || (i[0] = [
        o("div", { class: "tw-w-30 tw-h-5 tw-animate-pulse tw-bg-light" }, null, -1)
      ])))), 128))
    ]))), 128));
  }
}), dr = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-arrow-up",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, wr = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-arrow-down",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, cr = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-arrows-sort",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, Vi = /* @__PURE__ */ c({
  __name: "cl-th-sorting",
  props: {
    sortDirection: { type: [Boolean, String] }
  },
  setup(n) {
    const t = n, { sortDirection: e } = j(t);
    return (s, i) => (a(), l("div", {
      class: p([
        h(e) === !1 ? "tw-text-dorian-gray-200" : "tw-text-dorian-gray-500",
        "tw-ml-2"
      ])
    }, [
      h(e) === "asc" ? (a(), l("svg", dr, i[0] || (i[0] = [
        o("path", {
          stroke: "none",
          d: "M0 0h24v24H0z",
          fill: "none"
        }, null, -1),
        o("path", { d: "M12 5l0 14" }, null, -1),
        o("path", { d: "M18 11l-6 -6" }, null, -1),
        o("path", { d: "M6 11l6 -6" }, null, -1)
      ]))) : h(e) === "desc" ? (a(), l("svg", wr, i[1] || (i[1] = [
        o("path", {
          stroke: "none",
          d: "M0 0h24v24H0z",
          fill: "none"
        }, null, -1),
        o("path", { d: "M12 5l0 14" }, null, -1),
        o("path", { d: "M18 13l-6 6" }, null, -1),
        o("path", { d: "M6 13l6 6" }, null, -1)
      ]))) : (a(), l("svg", cr, i[2] || (i[2] = [
        o("path", {
          stroke: "none",
          d: "M0 0h24v24H0z",
          fill: "none"
        }, null, -1),
        o("path", { d: "M3 9l4 -4l4 4m-4 -4v14" }, null, -1),
        o("path", { d: "M21 15l-4 4l-4 -4m4 4v-14" }, null, -1)
      ])))
    ], 2));
  }
}), ur = { class: "tw-mr-4 tw-inline-flex tw-h-10 tw-items-baseline tw-justify-start" }, hr = {
  class: "tw-mr-4 tw-whitespace-nowrap tw-text-sm tw-text-dorian-gray-500",
  for: "row-per-page-select"
}, pr = ["value", "disabled"], fr = ["value"], Ti = /* @__PURE__ */ c({
  __name: "cl-table-page-size",
  props: {
    placeholder: {},
    pageSize: {},
    pageSizes: {},
    handlePageSizeChange: { type: Function },
    disabled: { type: Boolean }
  },
  setup(n) {
    const t = n, { placeholder: e, pageSize: s, pageSizes: i, handlePageSizeChange: r, disabled: d } = j(t);
    return (w, u) => (a(), l("div", ur, [
      o("label", hr, C(h(e)), 1),
      o("select", {
        id: "row-per-page-select",
        name: "row-per-page-select",
        class: "tw-focus:border-gray-200 peer tw-block tw-w-full tw-appearance-none tw-border-0 tw-border-b-2 tw-border-solid tw-border-dorian-gray-100/80 tw-bg-white tw-text-sm tw-text-dorian-gray-500 tw-outline-none focus:tw-border-secondary-500 focus:tw-ring-0",
        value: h(s),
        disabled: h(d),
        onChange: u[0] || (u[0] = //@ts-ignore
        (...m) => h(r) && h(r)(...m))
      }, [
        (a(!0), l(V, null, Z(h(i), (m) => (a(), l("option", {
          key: m,
          value: m
        }, C(m), 9, fr))), 128))
      ], 40, pr)
    ]));
  }
}), gr = {
  class: "tw-inline-flex",
  role: "group"
}, br = ["disabled", "data-test-id"], vr = ["disabled", "data-test-id"], Si = /* @__PURE__ */ c({
  __name: "cl-table-basic-pagination",
  props: {
    canPreviousPage: { type: Boolean },
    previousPage: {},
    canNextPage: { type: Boolean },
    nextPage: {},
    disabled: { type: Boolean },
    testId: { default: "cl-table-basic-pagination" }
  },
  setup(n) {
    const t = n, { canPreviousPage: e, previousPage: s, canNextPage: i, nextPage: r, disabled: d } = j(t);
    return (w, u) => (a(), l("div", gr, [
      o("button", {
        type: "button",
        class: "tw-bg-transparent tw-mr-[-1px] tw-rounded-l tw-border-2 tw-border-solid tw-border-secondary-500 tw-px-2 tw-text-sm tw-font-medium tw-text-dorian-gray-200 hover:tw-text-secondary-500 disabled:tw-cursor-default disabled:tw-border-r disabled:tw-border-dorian-gray-100/80 disabled:tw-text-dorian-gray-200",
        disabled: h(d) || !h(e),
        "data-test-id": `${t.testId}-previous`,
        onClick: u[0] || (u[0] = //@ts-ignore
        (...m) => h(s) && h(s)(...m))
      }, u[2] || (u[2] = [
        o("span", { class: "tw-sr-only" }, '"Previous Page"', -1),
        o("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          class: "icon icon-tabler icon-tabler-chevron-left",
          width: "16",
          height: "16",
          viewBox: "0 0 24 24",
          "stroke-width": "2",
          stroke: "currentColor",
          fill: "none",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          o("path", {
            stroke: "none",
            d: "M0 0h24v24H0z",
            fill: "none"
          }),
          o("path", { d: "M15 6l-6 6l6 6" })
        ], -1)
      ]), 8, br),
      o("button", {
        type: "button",
        class: "tw-bg-transparent tw-ml-[-1px] tw-rounded-r tw-border-2 tw-border-solid tw-border-secondary-500 tw-px-2 tw-text-sm tw-font-medium tw-text-dorian-gray-200 hover:tw-text-secondary-500 disabled:tw-cursor-default disabled:tw-border-l disabled:tw-border-dorian-gray-100/80 disabled:tw-text-dorian-gray-200",
        disabled: h(d) || !h(i),
        "data-test-id": `${t.testId}-next`,
        onClick: u[1] || (u[1] = //@ts-ignore
        (...m) => h(r) && h(r)(...m))
      }, u[3] || (u[3] = [
        o("span", { class: "tw-sr-only" }, '"Next Page"', -1),
        o("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          class: "icon icon-tabler icon-tabler-chevron-right",
          width: "16",
          height: "16",
          viewBox: "0 0 24 24",
          "stroke-width": "2",
          stroke: "currentColor",
          fill: "none",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          o("path", {
            stroke: "none",
            d: "M0 0h24v24H0z",
            fill: "none"
          }),
          o("path", { d: "M9 6l6 6l-6 6" })
        ], -1)
      ]), 8, vr)
    ]));
  }
}), mr = { class: "tw-mr-auto tw-inline-flex tw-h-10 tw-items-baseline tw-justify-start" }, _r = { class: "tw-text-sm tw-text-dorian-gray-500" }, ji = /* @__PURE__ */ c({
  __name: "cl-table-pagination-state",
  props: {
    start: {},
    end: {},
    total: {},
    placeholder: {}
  },
  setup(n) {
    const t = n, { start: e, end: s, total: i, placeholder: r } = j(t);
    return (d, w) => (a(), l("div", mr, [
      o("span", _r, [
        o("span", null, C(`${h(e)} - ${h(s)}`), 1),
        o("span", null, C(` ${h(r)} `), 1),
        o("span", null, C(h(i)), 1)
      ])
    ]));
  }
}), yr = ["disabled"], xr = {
  key: 0,
  id: "set-rows-wrapper",
  class: "tw-absolute tw-right-0 tw-z-10 tw-m-1 tw-flex tw-min-w-max tw-flex-col tw-rounded-md tw-border tw-border-dorian-gray-100 tw-bg-white tw-p-4 tw-pb-2 tw-shadow-md tw-transition-opacity"
}, Zi = /* @__PURE__ */ c({
  __name: "cl-table-column-visibility-toggle",
  props: {
    disabled: { type: Boolean, default: !1 }
  },
  setup(n) {
    const t = n, e = M(!1), s = () => {
      e.value = !e.value;
    }, i = k(() => t.disabled ? "tw-stroke-dorian-gray-200 tw-cursor-not-allowed" : e.value ? "tw-stroke-secondary-500" : "tw-stroke-dorian-gray-500 tw-transition-colors group-hover:tw-stroke-secondary-500"), r = M(null);
    return G(r, () => {
      e.value = !1;
    }), (d, w) => {
      const u = $t("cl-icon-tabler-table");
      return a(), l("div", {
        ref_key: "columnSetTooltip",
        ref: r
      }, [
        o("button", {
          class: "tw-group tw-mx-4 tw-flex tw-h-9 tw-cursor-pointer tw-items-center tw-justify-center tw-border-l-2 tw-border-solid tw-border-dorian-gray-100 tw-pl-4",
          disabled: d.disabled,
          onClick: s
        }, [
          L(u, {
            width: "24",
            height: "24",
            class: p(i.value)
          }, null, 8, ["class"])
        ], 8, yr),
        e.value ? (a(), l("div", xr, [
          g(d.$slots, "default")
        ])) : x("", !0)
      ], 512);
    };
  }
}), Cr = ["indeterminate"], Di = /* @__PURE__ */ c({
  __name: "cl-input-checkbox",
  props: {
    indeterminate: { type: Boolean },
    className: {}
  },
  setup(n) {
    const t = n, { indeterminate: e, className: s } = j(t);
    return (i, r) => (a(), l("input", U({
      type: "checkbox",
      class: ["tw-h-5 tw-w-5 tw-cursor-pointer tw-rounded tw-border-2 tw-border-solid tw-border-dorian-gray-500 tw-bg-white tw-text-secondary-500 checked:tw-border-secondary-500 focus:tw-ring-secondary-500 focus:tw-ring-offset-white disabled:tw-border-dorian-gray-100 disabled:tw-text-dorian-gray-100 disabled:checked:tw-border-dorian-gray-100", h(s)],
      indeterminate: h(e)
    }, i.$attrs), null, 16, Cr));
  }
}), kr = { class: "tw-relative tw-w-full" }, $r = { class: "tw-pointer-events-none tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3 tw-text-dorian-gray-200" }, Mr = ["width", "height"], Br = "focus:tw-border-secondary-500 focus:tw-ring-4 focus:tw-ring-secondary-500/10", Lr = "disabled:tw-cursor-not-allowed disabled:tw-bg-dorian-gray-50 disabled:tw-text-dorian-gray-500/50 disabled:tw-outline-none", Hr = "read-only:tw-cursor-default read-only:tw-bg-dorian-gray-50 read-only:tw-text-dorian-gray-500/50 read-only:tw-outline-none", Ai = /* @__PURE__ */ c({
  __name: "cl-input-search",
  props: {
    value: {},
    className: { default: void 0 },
    size: { default: "medium" },
    state: { type: Boolean, default: void 0 }
  },
  emits: ["update:value"],
  setup(n, { expose: t, emit: e }) {
    const s = n, i = {
      small: "tw-text-sm tw-py-1 tw-px-3 tw-pl-9",
      medium: "tw-text-base tw-py-2 tw-px-3 tw-pl-10",
      large: "tw-text-lg tw-py-3 tw-px-3 tw-pl-12"
    }, r = {
      none: "tw-border-dorian-gray-100/80",
      valid: "tw-border-success-500",
      error: "tw-border-danger-500"
    }, d = M(null), w = () => {
      d.value && d.value.focus();
    }, { className: u, size: m, state: v, value: $ } = j(s), y = k(() => [
      i[m.value],
      v.value === void 0 ? r.none : s.state ? r.valid : r.error,
      Br,
      Lr,
      Hr,
      u.value
    ]), B = k(() => m.value === "small" ? "14" : m.value === "medium" ? "18" : "24"), I = k({
      get() {
        return $.value;
      },
      set(P) {
        nt("update:value", P);
      }
    }), nt = e;
    return t({
      focus: w
    }), (P, W) => (a(), l("div", kr, [
      A(o("input", U(P.$attrs, {
        ref_key: "searchRef",
        ref: d,
        "onUpdate:modelValue": W[0] || (W[0] = (O) => I.value = O),
        type: "search",
        class: ["tw-block tw-w-full tw-rounded tw-border tw-bg-white tw-text-dorian-gray-500 tw-outline-none tw-ring-offset-1 tw-transition-all", y.value]
      }), null, 16), [
        [ct, I.value]
      ]),
      o("span", $r, [
        (a(), l("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          class: "icon icon-tabler icon-tabler-search",
          width: B.value,
          height: B.value,
          viewBox: "0 0 24 24",
          "stroke-width": "1.5",
          stroke: "currentColor",
          fill: "none",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, W[1] || (W[1] = [
          o("path", {
            stroke: "none",
            d: "M0 0h24v24H0z",
            fill: "none"
          }, null, -1),
          o("path", { d: "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" }, null, -1),
          o("path", { d: "M21 21l-6 -6" }, null, -1)
        ]), 8, Mr))
      ])
    ]));
  }
}), Pi = /* @__PURE__ */ c({
  __name: "cl-input-radio",
  props: {
    modelValue: { type: [String, Number, Boolean] }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: t }) {
    const e = n, s = t, { modelValue: i } = j(e), r = k({
      get() {
        return i.value;
      },
      set(d) {
        s("update:modelValue", d);
      }
    });
    return (d, w) => A((a(), l("input", {
      "onUpdate:modelValue": w[0] || (w[0] = (u) => r.value = u),
      class: "tw-border-dorian-gray-70 tw-my-2 tw-ml-4 tw-mr-2 tw-h-5 tw-w-5 tw-cursor-pointer tw-border-2 tw-border-solid tw-border-dorian-gray-500 tw-bg-white tw-text-secondary-500 checked:tw-border-secondary-500 focus:tw-ring-secondary-500 focus:tw-ring-offset-white",
      type: "radio"
    }, null, 512)), [
      [ae, r.value]
    ]);
  }
}), Ir = { class: "tw-px-4" }, zr = ["data-test-id"], Vr = { class: "tw-flex tw-items-center tw-justify-between" }, Tr = { key: 0 }, Ei = /* @__PURE__ */ c({
  __name: "cl-accordion",
  props: {
    testId: { default: "cl-accordion-toggle-btn" },
    isOpenDefault: { type: Boolean, default: !1 }
  },
  setup(n) {
    const t = n, [e, s] = ke(t.isOpenDefault);
    return (i, r) => (a(), l("div", null, [
      o("div", Ir, [
        o("button", {
          class: "tw-block tw-w-full",
          "data-test-id": i.testId,
          onClick: r[0] || (r[0] = (d) => h(s)())
        }, [
          o("div", Vr, [
            g(i.$slots, "summary"),
            o("div", null, [
              L(h(ot), {
                class: p(["tw-transition-transform", h(e) ? "tw-rotate-180" : "tw-rotate-0"])
              }, null, 8, ["class"])
            ])
          ])
        ], 8, zr),
        h(e) ? (a(), l("div", Tr, [
          g(i.$slots, "details")
        ])) : x("", !0)
      ]),
      L(ve, { size: "md" })
    ]));
  }
}), Sr = { class: "tw-relative tw-grid tw-grid-cols-6 tw-gap-2" }, jr = { class: "tw-col-span-4 tw-flex tw-items-center" }, Zr = {
  key: 0,
  class: "tw-col-span-2 tw-flex tw-items-center"
}, Ni = /* @__PURE__ */ c({
  __name: "cl-progress-bar",
  props: {
    total: { default: 0 },
    completed: { default: 0 },
    showNumbers: { type: Boolean, default: !0 }
  },
  setup(n) {
    const t = n, { total: e, completed: s, showNumbers: i } = j(t), r = k(() => s.value / e.value * 100), d = {
      green: "tw-bg-success-100",
      yellow: "tw-bg-warning-100",
      red: "tw-bg-danger-100"
    }, w = {
      green: "tw-bg-success-400",
      yellow: "tw-bg-warning-400",
      red: "tw-bg-danger-400"
    }, u = k(() => e.value === 0 ? d.red : r.value > 70 ? d.green : r.value < 70 && r.value > 35 ? d.yellow : d.red), m = k(() => e.value === 0 ? d.red : r.value > 70 ? w.green : r.value < 70 && r.value > 35 ? w.yellow : w.red), v = k(() => e.value === 0 ? "width: 0%" : `width: ${r.value}%`), $ = st(), y = k(() => $.text && !t.showNumbers);
    return (B, I) => (a(), l("div", Sr, [
      o("div", jr, [
        o("div", {
          class: p(["tw-relative tw-h-3.5 tw-w-full tw-rounded-md", u.value])
        }, [
          o("div", {
            class: p(["tw-h-3.5 tw-w-full tw-rounded-md", m.value]),
            style: le(v.value)
          }, null, 6)
        ], 2)
      ]),
      h(i) ? (a(), l("div", Zr, C(`${h(s)}/${h(e)}`), 1)) : x("", !0),
      y.value ? g(B.$slots, "text", {
        key: 1,
        class: "tw-col-span-2 tw-flex tw-items-center"
      }) : x("", !0)
    ]));
  }
});
export {
  Ei as ClAccordion,
  xi as ClActiveFilter,
  ri as ClBadge,
  ii as ClBadgeLabel,
  ci as ClBreadcrumbs,
  wt as ClButton,
  Y1 as ClCard,
  ei as ClCardTrend,
  ui as ClCheckbox,
  W1 as ClDataTable,
  K1 as ClDataTableDeleteAction,
  G1 as ClDataTableEditAction,
  q1 as ClDataTableMoreAction,
  J1 as ClDataTableMoreActionItem,
  Q1 as ClDataTableViewAction,
  si as ClDropdown,
  ni as ClDropdownItem,
  di as ClEmailAttachment,
  yi as ClFooter,
  Ar as ClFormGroup,
  Er as ClFormInput,
  Pr as ClFormLabel,
  hi as ClFormRadioGroup,
  mi as ClFormSelect,
  vi as ClFormTextarea,
  fi as ClHeaderDropdown,
  bi as ClHeaderDropdownLink,
  gi as ClHeaderDropdownProduct,
  ht as ClHeading,
  ve as ClHr,
  Gr as ClIconArrowUpRight,
  Wr as ClIconBoxArrowInLeft,
  Ur as ClIconColumnsGap,
  D1 as ClIconEmptyBox,
  E1 as ClIconEmptyDashboard,
  P1 as ClIconEmptyEmail,
  A1 as ClIconEmptyFolder,
  f1 as ClIconEnvelopeAt,
  g1 as ClIconEnvelopeLetter,
  Ke as ClIconList,
  b1 as ClIconPaperBoard,
  Qr as ClIconPencilSquare,
  H1 as ClIconTableCheck,
  x1 as ClIconTablerAdjustmentsHorizontal,
  Z1 as ClIconTablerAlertCircleFilled,
  y1 as ClIconTablerAlertTriangle,
  L1 as ClIconTablerArchive,
  as as ClIconTablerArrowDown,
  r1 as ClIconTablerArrowFork,
  i1 as ClIconTablerArrowForkLeft,
  rs as ClIconTablerArrowUp,
  s1 as ClIconTablerBriefcase,
  _1 as ClIconTablerCalendarEvent,
  ot as ClIconTablerChevronDown,
  ds as ClIconTablerChevronLeft,
  Lt as ClIconTablerChevronRight,
  vs as ClIconTablerCircleCheck,
  Ls as ClIconTablerCircleCheckFilled,
  v1 as ClIconTablerCopy,
  Kr as ClIconTablerDashboard,
  ss as ClIconTablerDotsVertical,
  ko as ClIconTablerDownload,
  Io as ClIconTablerEdit,
  a1 as ClIconTablerEditCircle,
  z1 as ClIconTablerExternalLink,
  Bo as ClIconTablerFile,
  V1 as ClIconTablerFileTypePdf,
  M1 as ClIconTablerFishHook,
  qr as ClIconTablerFlag3,
  k1 as ClIconTablerForbid,
  l1 as ClIconTablerHistory,
  Jr as ClIconTablerIconBulb,
  Xr as ClIconTablerIconChartBar,
  To as ClIconTablerIconEye,
  Yr as ClIconTablerIconRecharging,
  Ht as ClIconTablerInfoCircle,
  m1 as ClIconTablerInfoFilled,
  p1 as ClIconTablerLifebuoy,
  h1 as ClIconTablerLogout,
  u1 as ClIconTablerMail,
  C1 as ClIconTablerMailCheck,
  d1 as ClIconTablerReportAnalytics,
  B1 as ClIconTablerSchool,
  zt as ClIconTablerSearch,
  t1 as ClIconTablerSettings,
  w1 as ClIconTablerShieldCheck,
  c1 as ClIconTablerShieldLock,
  T1 as ClIconTablerSparkles,
  S1 as ClIconTablerSparklesHorizontal,
  Yo as ClIconTablerTable,
  es as ClIconTablerTrash,
  fs as ClIconTablerUser,
  $1 as ClIconTablerUserPlus,
  n1 as ClIconTablerWordUp,
  I1 as ClIconTablerWorldCheck,
  It as ClIconTablerX,
  j1 as ClIconTablerZoomExclamation,
  Di as ClInputCheckbox,
  Pi as ClInputRadio,
  Ai as ClInputSearch,
  oi as ClModal,
  Or as ClP,
  X1 as ClPill,
  Ni as ClProgressBar,
  Fr as ClSidebar,
  F1 as ClSidebarDropdown,
  U1 as ClSidebarDropdownMenuItem,
  R1 as ClSidebarDropdownSearch,
  O1 as ClSidebarNav,
  N1 as ClSidebarNavItemChild,
  Rr as ClSidebarNavItemParent,
  xt as ClSkeleton,
  ti as ClSkeletonRow,
  Nr as ClSpinner,
  _i as ClStepper,
  wi as ClSwitcher,
  $i as ClTable,
  Si as ClTableBasicPagination,
  Zi as ClTableColumnVisibilityToggle,
  Ti as ClTablePageSize,
  ji as ClTablePaginationState,
  ki as ClTableWrapper,
  o1 as ClTablerIconBuildingSkyscraper,
  e1 as ClTablerIconUsers,
  ai as ClTabs,
  li as ClTabsItem,
  Bi as ClTbody,
  Ii as ClTd,
  Hi as ClTh,
  Vi as ClThSorting,
  Mi as ClThead,
  pi as ClToast,
  Ci as ClToggle,
  Vt as ClTooltip,
  Li as ClTr,
  zi as ClTrSkeleton
};
//# sourceMappingURL=frontend-component-library.es.js.map
